import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  ChangeEvent,
} from "react";
import Select from "react-select";
import { defaultAppContextData } from "../../services/appData";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import {
  getCAVSMaster,
  getBioCountryOfDestination,
  getBioCountryOfOrigin,
  SaveTERDraftApplications,
  saveTERCancellation,
  getTERApplication,
  getBreedSpeciesSpecimensDetails,
  getBreedSpecimenBySpecies,
  saveResultRequest,
  saveAckRequest,
  PremiseCodeDetails,
  getAmendmentHistory,
} from "../../api/apimethods";
import { TypeOfApplicationEnum, ApplicationTypeEnum } from "../../utils/enum";
import { useSearchParams } from "react-router-dom";
import { Button, Modal, Spinner, Tab, Tabs } from "react-bootstrap";
import { ITestPshCavsCodeMasterModel } from "../../typings/models/PshCavsTestCodeMasterModel";
import Stepwizard from "../LabDetails/Helper/Stepwizard";
import { getPshCavsTestCodeMaster } from "../../api/apimethods";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import {
  ITERRequest,
  defTERCancelAppStatus,
} from "../../typings/interfaces/Requests/TERRequest";
import { getCountries } from "../../api/apimethods";
import { IlabTERPreference } from "../../typings/models/TERPreference";
import { notify } from "../../utils";
import { helper } from "../../utils/helper";
import { useNavigate, useLocation } from "react-router-dom";
import { IAmendmentHistoryResponse } from "../../typings/interfaces/Responses/LabApplicationsResponse";
import AmendmentGrid from "./AmendmentGrid";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import { ILabTestDetails } from "../../typings/models/LabTestDetails";
import { ITERSampleDetails } from "../../typings/models/TERSampleDetails";
import { ITERSamplesAndTests } from "../../typings/models/TERSamplesAndTests";
import PersonalInformation, {
  initialPersonalInfo,
} from "./Helper/ProfileInformation";
import moment from "moment";
import { faCopy, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import {
  faCircleExclamation,
  faInfoCircle,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TERMetaContext } from "../../App";
import { IChooseApp } from "../../typings/models/ChooseApp";
import {
  IFilerInformation,
  tempFilerInfo,
} from "../../typings/models/FilerInformation";
import { IPersonalInfo } from "../../typings/models/PersonalInfo";
import { IBioPurposeOfTest } from "../../typings/models/BioPurposeOfTest";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import { ITERApplicationDetails } from "../../typings/models/TERApplicationDetails";
import FileSaver from "file-saver";
import { ILabBreedMaster } from "../../typings/models/LabBreedMaster";
import { ILabSpeciesMaster } from "../../typings/models/LabSpeciesMaster";
import { ILabSpecimenMaster } from "../../typings/models/LabSpecimenMaster";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import { ITestResult } from "../../typings/interfaces/Requests/TestResult";
import Loader from "../../components/molecules/Loader";
import { useContextService } from "../../services";
export interface PersonalInfo {
  customerName: string;
  mobileNumber: string;
  email: string;
  address: string;
  homeNumber: string;
  customerNRIC: string;
  modeOfPayment: string;
  typeOfService: string;
  typeOfApplication: number;
  projectName: string;
  specialInstruction: string;
  otherRemarks: string;
}
enum sampleDetailMandatoryFields {
  purposeOfTest = "purposeOfTest",
  healthy = "healthy",
  samplingFromDate = "samplingFromDate",
  samplingToDate = "samplingToDate",
  sampledBy = "sampledBy",
  countryofBirth = "countryofBirth",
}
enum SamplesAndTestMandatoryFields {
  sampleMarking = "sampleMarking",
  species = "species",
  breed = "breed",
  specimenDescription = "specimenDescription",
  labTERTestDetails = "labTERTestDetails",
}
enum PreferenceMandatoryFields {
  modeOfReceiving = "modeOfReceiving",
}
enum ResultMandatoryFields {
  resultcode = "resultcode",
  testingInstructions = "testingInstructions",
  remarksForThirdParty = "remarksForThirdParty",
}
type RepeatCounts = {
  [sampleIndex: number]: {
    [testIndex: number]: number;
  };
};
function CAVSTERSampleDetails() {
  const location = useLocation();
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate());
  const maxdate = currentDate.toISOString().split("T")[0];
  const maxDateTime = currentDate.toISOString().slice(0, 16);
  const { message } = notify();
  const fieldOptionPairs = [
    { field: "noDiseased", option: "noOrDiseasedOptions" },
    { field: "totalNoofunits", option: "noOfUnitsOptions" },
    { field: "unitSize", option: "unitsizeoptions" },
    { field: "farmArea", option: "farmAreaOptions" },
    { field: "ageAffected", option: "ageAffectedOptions" },
  ];

  const stripHtmlTags = (str: string) => {
    return str.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, "");
  };
  const strippedHtmlTags = (str: string) => {
    return str.replace(/<\/?[^>]+(>|$)/g, "").trim();
  };
  let labTERPreferenceSchema: IlabTERPreference = {
    specialInstructions: "",
    remarks: "",
    supportDocuments: [],
    supportDocumentName: "",
    hardcopy: "",
    modeOfReceiving: 0,
    customAddress: "",
    antimicrobialSusceptibilityTestRequired: false,
    acknowledge: false,
  };

  interface PostMortemConsentForm {
    ID: string;
    postMortemConsentFormName: string;
    postMortemConsentForm: string;
  }
  const reportTypeNames: { [key: number]: string } = {
    1: "Casesheet",
    2: "Laboratory Report",
    3: "Acknowledgment Slip",
    4: "Sample Label",
  };
  const [reports, setReports] = useState<
    {
      reportName: string;
      reportData: string;
      reportType: number;
      reportID: string;
      applicationId: string;
      isReportGenerated: any;
    }[]
  >([]);
  const postMartemFields = [
    "resultcode",
    "testingInstructions",
    "remarksForThirdParty",
  ];
  const renderReportType = (type: number) => {
    return reportTypeNames[type] || "Laboratory Report";
  };
  const navigate = useNavigate();
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const currentStep = location.state?.currentStep || 2;
  const [testDescription, setTestDescription] = useState<string>("");
  const [originalSampleDetails, setOriginalSampleDetails] =
    useState<ITERSampleDetails | null>(null);
  const [originalSamplesAndTests, setOriginalSamplesAndTests] = useState<
    ITERSamplesAndTests[]
  >([]);
  const [isVaccinationHistoryExpanded, setIsVaccinationHistoryExpanded] =
    useState(false);
  const [params, setParams] = useSearchParams();
  const [isCancelRequest, setIsCancelRequest] = useState<boolean>(false);
  const [testStatus, setTestStatus] = useState<string>("");
  const [cancelComments, setCancelComments] = useState<string>("");
  const [customerNRIC, setCustomerNRIC] = useState("");
  const [isThirdPartyLab, setisThirdPartyLab] = useState<string>("");
  const [cancelCommentsErrMsg, setCancelCommentsErrMsg] = useState<string>("");
  const [rejectedTestsMessage, setRejectedTestsMessage] = useState("");
  const [showAdditionalContent, setShowAdditionalContent] = useState(false);
  const [submittedFeedback, setSubmittedFeedback] = useState<number>(0);
  const [validDates, setValidDates] = useState<boolean>(false);
  const [thirdPartyNric, setthirdPartyNric] = useState<string>("");
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<IBioPurposeOfTest[]>();
  const { btnLoaderHandler, fileToBase64, getFilerInfomation } = helper();
  const [cancelButtonHidden, setCancelButtonHidden] = useState(false);
  const [bioSurveillanceProgramsOptions, setBioSurveillanceProgramsOptions] =
    useState<IReactSelectOption[]>([]);
  const [personalInfo, setPersonalInfo] =
    useState<IPersonalInfo>(initialPersonalInfo);
  const [activeTab, setActiveTab] = useState<number>(1);
  const [actionType, setActionType] = useState<string>("");
  const [RedMessage, setRedMessage] = useState("");
  const [cancelMessage, setcancelMessage] = useState<string | null>(null);
  const [BioSurveillanceValues, setBioSurveillanceValues] = useState<string[]>(
    []
  );
  const [IsBiosurvillanceUser, setIsBiosurvillanceUser] = useState(false);
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const [checkpageLoader, setcheckPageLoader] = useState<boolean>(false);
  const [originalPreference, setOriginalPreference] =
    useState<IlabTERPreference>(labTERPreferenceSchema);
  const [clinicalHistoryOptions, setClinicalHistoryOptions] =
    useState<IBioPurposeOfTest[]>();
  const [IsSubmitresultRequest, setIsSubmitresultRequest] =
    useState<boolean>(false);
  const [IsAcknowledge, setIsAcknowledge] = useState<boolean>(false);
  const [ResultCodeOptions, setResultCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [hasFetchedInitialData, setHasFetchedInitialData] = useState(false);
  const [repeatCounts, setRepeatCounts] = useState<RepeatCounts>({});
  const [labTestID, setlabTestID] = useState<string>("");
  const [IsAcknowledgeRequest, setIsAcknowledgeRequest] =
    useState<boolean>(false);
  const [speciesOptions, setSpeciesOptions] = useState<ILabSpeciesMaster[]>();
  const [reportgenerated, setreportgenerated] = useState<number>(0);
  const [premisesCodeOptions, setpremisesCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [breedOptions, setBreedOptions] = useState<ILabBreedMaster[]>();
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };
  const [countryOptions, setCountryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [specimenOptions, setSpecimenOptions] =
    useState<ILabSpecimenMaster[]>();
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [selectedTestLaboratory, setSelectedTestLaboratory] =
    useState("All-laboratories");
  const [amendCase, setAmendCase] = useState<string>("");
  const [countries, setCountries] = useState<any[]>([]);
  const handleShowModal = () => setShowModal(true);
  const [labtestoptions, setlabtestoptions] = useState<
    ITestPshCavsCodeMasterModel[]
  >([]);
  const [isPostMartem, setIsPostMartem] = useState(0);
  const [addressType, setAddressType] = useState<string>("");
  const [showPostMortem, setShowPostMortem] = useState(true);
  const [isClinicalManagementExpanded, setIsClinicalManagementExpanded] =
    useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showGroupAnimals, setShowGroupAnimals] = useState(true);
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const [applicationNum, setApplicationNum] = useState<string>("");
  const [searchInd, setSearchInd] = useState(-1);
  const [showForm, setShowForm] = useState(false);
  const [showFarmDetails, setShowFarmDetails] = useState(true);
  const [showFarmLocationDetails, setShowFarmLocationDetails] = useState(false);
  const [euthanised, setEuthanised] = useState<boolean>(false);
  const [showQuarantineInfo, setShowQuarantineInfo] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [customerName, setCustomerName] = useState<string>("");
  const [salutation, setSalutation] = useState<string>("");
  const [selectedTestIds, setSelectedTestIds] = useState<
    (number | undefined)[]
  >([]);
  const [speciesSelectOptions, setSpeciesSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [copyCount, setCopyCount] = useState<number>(1);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAmendmentHistory, setShowAmendmentHistory] = useState(false);
  const [amendmentHistory, setAmendmentHistory] = useState<
    IAmendmentHistoryResponse[]
  >([]);
  const [testOptions, setTestOptions] = useState<ITestPshCavsCodeMasterModel[]>(
    []
  );
  const [modeOfPayment, setModeOfPayment] = useState<string>(
    localStorage.getItem("modeOfPayment") || ""
  );
  const testRowId = Number(params.get("rowId") ?? "");
  const [showTooltip, setShowTooltip] = useState(false);
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [Preference, setPreference] = useState<IlabTERPreference>(
    labTERPreferenceSchema
  );
  const handleToggleForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowForm((prevShowForm) => !prevShowForm);
  };
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  const toggleClinicalManagement = () => {
    setIsClinicalManagementExpanded((prev) => !prev);
  };
  const handleDiseaseSignClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowAdditionalContent(!showAdditionalContent);
  };
  const handledremoveFile = (
    fileName: string,
    sampleIndex: number,
    fileIndex: number
  ) => {
    setSamplesAndTests((prevState) => {
      return prevState.map((sample, index) => {
        if (index !== sampleIndex) {
          return sample;
        }

        if (typeof sample.postMortemConsentFormName !== "string") {
          return sample;
        }

        const fileNamesArray = sample.postMortemConsentFormName.split(", ");

        if (fileIndex < 0 || fileIndex >= fileNamesArray.length) {
          return sample;
        }

        const updatedFileNamesArray = fileNamesArray.filter(
          (_, i) => i !== fileIndex
        );

        const updatedPostMortemConsentForms = Array.isArray(
          sample.postMortemConsentForms
        )
          ? sample.postMortemConsentForms.filter((_, i) => i !== fileIndex)
          : [];

        const updatedSample = {
          ...sample,
          postMortemConsentForms: updatedPostMortemConsentForms,
          postMortemConsentFormName: updatedFileNamesArray.join(", "),
        };

        return updatedSample;
      });
    });
  };

  const handledFiledChange = async (
    sampleIndex: number,
    testLabTestID: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      const files = Array.from(event.target.files);
      const base64Files = await Promise.all(
        files.map((file) => fileToBase64(file))
      );

      const newResultDocuments = base64Files.filter(
        (base64) => base64.length > 0
      );
      const newResultDocumentNames = files.map((file) => file.name);

      setSamplesAndTests((prevState) => {
        const updatedSamples = prevState.map((sample, sIndex) => {
          const updatedLabTERTestDetail = sample.labTERTestDetails.map(
            (test) => {
              if (test.labTestID === testLabTestID) {
                const updatedResultDocuments = [
                  ...(test.ResultDocuments || []),
                  ...newResultDocuments,
                ];
                const updatedResultDocumentNames = [
                  ...(test.ResultDocumentName
                    ? test.ResultDocumentName.split(", ")
                    : []),
                  ...newResultDocumentNames,
                ];

                return {
                  ...test,
                  ResultDocuments: updatedResultDocuments,
                  ResultDocumentName: updatedResultDocumentNames.join(", "),
                };
              }
              return test;
            }
          );

          return {
            ...sample,
            labTERTestDetails: updatedLabTERTestDetail,
          };
        });

        return updatedSamples;
      });
    }
  };

  const handleEuthanisedChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const isChecked = event.target.checked;
    setEuthanised(isChecked);

    setSamplesAndTests((prevState) =>
      prevState.map((item, i) =>
        i === index ? { ...item, euthanised: isChecked } : item
      )
    );
  };

  const handleSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    fetchTestCodeMaster();
  };
  const fetchTestCodeMaster = async () => {
    try {
      handleLoader(true, "submit-reqq");
      const response: any = await getPshCavsTestCodeMaster({
        PurposeCode: "TER",
        IsBiosurvillanceUser: IsBiosurvillanceUser,
      });

      if (response.data && response.data.cavs) {
        const selectedLabTitle = selectedTestLaboratory;
        let searchString: string = testDescription || "";
        const cavsData = response.data.cavs;

        const formatDescription = (description: string) => {
          return description.replace(/<i>/g, "<em>").replace(/<\/i>/g, "</em>");
        };
        if (selectedLabTitle === "All-laboratories") {
          const filteredData = cavsData.filter((item: any) =>
            item.description
              ? stripHtmlTags(item.description)
                  .toLowerCase()
                  .includes(searchString.toLowerCase())
              : false
          );

          const transformedData = filteredData.map((item: any) => ({
            description: formatDescription(item.description),
            labGroupId: item.labGroupId,
            labGroup: item.labGroup,
            labCodeMasterID: item.labCodeMasterID,
            testMethodSOPDescription: item.testMethodSOPDescription,
          }));
          setTestOptions(transformedData);
        } else {
          const labGroupId = labtestoptions.find(
            (item: any) => item.labGroup === selectedLabTitle
          )?.labGroupId;

          if (!labGroupId) {
            console.error(
              "Lab Master ID not found for the selected laboratory labGroup:",
              selectedLabTitle
            );
            return;
          }

          const customFilter = cavsData.filter(
            (x: any) =>
              x.labGroupId === labGroupId &&
              (x.name
                ? stripHtmlTags(x.name)
                    .toLowerCase()
                    .includes(searchString.toLowerCase())
                : false)
          );

          const transformedData = customFilter.map((item: any) => ({
            description: formatDescription(item.description),
            labGroupId: item.labGroupId,
            labGroup: item.labGroup,
            labCodeMasterID: item.labCodeMasterID,
            testMethodSOPDescription: item.testMethodSOPDescription,
          }));
          setTestOptions(transformedData);
        }
      } else {
        const errorMessage = "Failed to retrieve the CAVS data from the API";

        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching test code master data:", error);
    } finally {
      handleLoader(false, "submit-reqq");
    }
  };
  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch(e as unknown as React.MouseEvent<HTMLButtonElement>);
  };
  const handleSelectedChange =
    (name: string) => (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      } as React.ChangeEvent<HTMLSelectElement>;
      handleTERSampleDetails(event, "string");
    };

  const getMaster = async () => {
    try {
      setPageLoader(true);
      const getUserInfo = localStorage.getItem("app-data");
      const userInfo = JSON.parse(getUserInfo || "");
      let NRIC = userInfo?.user?.idNo || null;
      let UEN = userInfo?.user?.uen || null;
      let role = userInfo?.user?.role || "";
      setCustomerNRIC(role === "CorpPass" ? UEN : NRIC);
      const customerIdentifier = role === "CorpPass" ? UEN : NRIC;
      const response = await getCAVSMaster();

      if (response?.status === 200) {
        let cavsMaster = response.data;
        let bioMaster = cavsMaster.bioMasters;

        if (bioMaster) {
          let purposeTest = bioMaster.testPurpose;
          let values = Object.values(purposeTest);
          let role = userInfo?.user?.role || "";
          let purposeTestArr = Object.keys(purposeTest).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          if (bioMaster.bioSurveillances) {
            const fetchedBioSurveillanceValues = bioMaster.bioSurveillances.map(
              (service: any) => service.uen
            );
            setBioSurveillanceValues(fetchedBioSurveillanceValues);
            const isBioUser =
              Array.isArray(fetchedBioSurveillanceValues) &&
              fetchedBioSurveillanceValues.includes(customerIdentifier);
            setIsBiosurvillanceUser(isBioUser);
          }

          setPurposeOfTestOptions(purposeTestArr);
          const resultCode = bioMaster.resultCodeMaster;
          if (resultCode) {
            const resultCodeArr = resultCode.map((result: any) => ({
              label: result.resultCodeName,
              value: result.resultCodeId,
            }));
            setResultCodeOptions(resultCodeArr);
          }
          const bioSurveillanceProgram = bioMaster.bioSurveillancePrograms;
          if (bioSurveillanceProgram) {
            const bioSurveillanceProgramArr = bioSurveillanceProgram.map(
              (result: any) => ({
                label: result.name,
                value: result.CodeValue,
              })
            );
            setBioSurveillanceProgramsOptions(bioSurveillanceProgramArr);
            const premisesMaster = bioMaster.premisesMaster;
            if (premisesMaster) {
              const premisesCodeOptions = premisesMaster.map((result: any) => ({
                label: result.premisesCode,
                value: result.premisesCode,
              }));

              setpremisesCodeOptions(premisesCodeOptions);
            }
          }
        }

        let clinicalHistory = response?.data?.bioMasters?.clinicalHistory;
        if (clinicalHistory) {
          let values = Object.values(clinicalHistory);
          let clinicalHistoryArr = Object.keys(clinicalHistory).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setClinicalHistoryOptions(clinicalHistoryArr);
        }
      }

      const countryRes = await getBioCountryOfDestination();
      const countryOptions = (countryRes?.data || []).map((country) => ({
        value: country.name,
        label: country.name,
      }));
      console.log('Country Options loaded:', countryOptions.length, 'countries');
      setCountryOptions(countryOptions);
      const profileInfo = localStorage.getItem("profile-info");
      if (profileInfo) {
        const parsedProfileInfo = JSON.parse(profileInfo);
        const nric = parsedProfileInfo.customerNRIC;
      }
      const breedspeciesresponse = await getBreedSpeciesSpecimensDetails("TER");

      if (breedspeciesresponse.status == 200) {
        let species = breedspeciesresponse?.data?.labSpecies;

        if (species) {
          let values: any[] = Object.values(species);
          let speciesArr: any[] = Object.keys(species).map((x, ind) => {
            return {
              speciesName: values[ind].speciesName,
            };
          });
          setSpeciesOptions(speciesArr);
        }
      }

      const meta = TERMeta.TERMeta;
      if (Object.keys(meta).length) {
        const {
          labTERApplicationDetails,
          labTERSampleTests,
          labTERPreference,
        } = meta;

        setTERSampleDetails(labTERApplicationDetails);
        setSamplesAndTests(labTERSampleTests);
        setPreference(labTERPreference);
        const fromDate = meta.labTERApplicationDetails.samplingFromDate;
        const toDate = meta.labTERApplicationDetails.samplingToDate;

        if (moment(fromDate).isValid() && moment(toDate).isValid()) {
          setValidDates(true);
        } else {
          setValidDates(false);
        }
      }
      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };

  const handleShowAmendmentHistory = async (appNo: string) => {
    if (!appNo) return;

    try {
      const amdresponse = await getAmendmentHistory(appNo);
      setAmendmentHistory(amdresponse);
      setShowAmendmentHistory(true);
    } catch (error) {
      console.error("Error fetching amendment history:", error);
    }
  };

  useEffect(() => {
    getMaster();
  }, []);

  const prevModeOfPaymentRef = useRef(modeOfPayment);
  useEffect(() => {
    if (modeOfPayment === "Biosurveillance") {
      setTERSampleDetails((prevDetails) => ({
        ...prevDetails,
        purposeOfTest: 1,
      }));
    } else if (prevModeOfPaymentRef.current === "Biosurveillance") {
      setTERSampleDetails((prevDetails) => ({
        ...prevDetails,
        purposeOfTest: 0,
      }));
    }

    prevModeOfPaymentRef.current = modeOfPayment;
  }, [modeOfPayment]);

  useEffect(() => {
    if (IsSubmitresultRequest || IsAcknowledge) {
      setActiveTab(4);
    }
  }, [IsSubmitresultRequest, IsAcknowledge]);

  const generateRejectedTestsMessage = (samplesAndTests: any[]) => {
    let message = "Please be noted that the Test: ";
    let rejectedTests: string[] = [];

    samplesAndTests.forEach((sample: any, sampleIndex: number) => {
      const sampleMarking = sample.sampleMarking;
      sample.labTERTestDetails.forEach((test: any) => {
        if (test.testStatus === 6) {
          rejectedTests.push(
            `${test.testDescription} under Sample ${
              sampleIndex + 1
            } (${sampleMarking})`
          );
        }
      });
    });

    if (rejectedTests.length > 0) {
      message += rejectedTests.join(", ") + " is/are Rejected.";
    } else {
      message = "";
    }

    return message;
  };

  useEffect(() => {
    /* Check for query string */
    async function checkQueryString() {
      try {
        setcheckPageLoader(true);
        const applicationNum: string | null = params.get("an");
        const getUserInfo = localStorage.getItem("app-data");
        const userInfo = JSON.parse(getUserInfo || "");
        let NRIC = userInfo?.user?.idNo || "";
        const isMetadata = localStorage.getItem("ismetadata");
        const actionType: string | null = params.get("type");
        setActionType(actionType || "");
        setApplicationNum(applicationNum || "");
        let isNricRequired = 1;

        if (
          actionType === TypeOfApplicationEnum.submitresult ||
          actionType === TypeOfApplicationEnum.Acknowledge
        ) {
          isNricRequired = 0;
        }

        if (applicationNum && actionType) {
          const getTER = await getTERApplication(
            applicationNum,
            NRIC,
            isNricRequired
          );
          if (getTER.status === 200) {
            setShowPlaceholder(false);
            let result: ITERRequest = getTER.data.result;
            if (result?.labTERApplicationDetails) {
              const fromDate = result.labTERApplicationDetails.samplingFromDate;
              const toDate = result.labTERApplicationDetails.samplingToDate;

              if (moment(fromDate).isValid() && moment(toDate).isValid()) {
                setValidDates(true);
              } else {
                setValidDates(false);
              }
            }
            const feedback = result?.submittedFeedback || 0;
            const reportgenerated = result?.isReportGenerated || 0;
            const reports = Array.isArray(result?.labReportDetails)
              ? result.labReportDetails
              : [];
            setReports(reports);
            setSubmittedFeedback(feedback);
            setreportgenerated(reportgenerated);
            if (isMetadata !== "1") {
              setTERSampleDetails(result?.labTERApplicationDetails as any);
              setOriginalSampleDetails(result?.labTERApplicationDetails as any);
              setOriginalPreference(result?.labTERApplicationDetails as any);
              setPreference(result?.labTERPreference);
              const personalInfoDetails = result?.labTERPersonalInfoDetails;
              setPersonalInfo(personalInfoDetails);

              if (result?.labTERPersonalInfoDetails?.contact) {
                setCustomerName(result.labTERPersonalInfoDetails.customerName);

                setSalutation(
                  result.labTERPersonalInfoDetails.contact.salutation
                );
              }
            }
            if (result?.labTERSampleTests?.length > 0) {
              localStorage.setItem(
                "choose-app",
                JSON.stringify(result.labTERChooseApplDetails)
              );
              const actionedStatus = result?.actionStatus;
              if (actionedStatus) {
                localStorage.setItem("psh-app-status", actionedStatus);
                localStorage.setItem("psh-app-applicationNum", applicationNum);
              }

              if (
                actionType == TypeOfApplicationEnum.amendment &&
                result?.actionStatus
              ) {
                let amendCase = "";

                if (result.actionStatus === "Pending Sample(s)") {
                  amendCase = "CASE3";
                } else {
                  amendCase = "CASE4";
                }

                setAmendCase(amendCase);
              } else if (actionType == TypeOfApplicationEnum.cancel) {
                setIsCancelRequest(true);
              } else if (actionType === TypeOfApplicationEnum.submitresult) {
                setIsSubmitresultRequest(true);
              } else if (actionType === TypeOfApplicationEnum.Acknowledge) {
                setIsAcknowledge(true);
              } else if (actionType == TypeOfApplicationEnum.acknowledgement) {
                setIsAcknowledgeRequest(true);
              }

              const appNo = params.get("an") ?? "";
              if (
                appNo &&
                result?.labTERChooseApplDetails?.applicationType ==
                  ApplicationTypeEnum.amendment
              ) {
                handleShowAmendmentHistory(appNo);
                setShowAmendmentHistory(true);
              }

              let samplesAndTests = result.labTERSampleTests.map(
                (sample, index) => {
                  const postmartem = sample.labTERTestDetails.map(
                    (obj: any) => ({
                      isPostMartem: obj.isPostMartem,
                      labTestID: obj.labTestID,
                      testStatus: obj.testStatus,
                      rowId: obj.rowId,
                      nooftestsrequired: obj.nooftestsrequired,
                      noOfSamples: obj.noOfSamples,
                      isThirdPartyLab: obj.isThirdPartyLab,
                      thirdPartyNric: obj.thirdPartyNric,
                      testMethodSOPDescription: obj.testMethodSOPDescription,
                      disableDelete: true,
                      testDescription: obj.description || obj.testDescription,
                      labTERTestResult: [defaultTestResult],
                    })
                  );

                  if (actionType == TypeOfApplicationEnum.submit) {
                    sample.postMortemConsentForms = [];
                    sample.postMortemConsentFormName = "";
                  }

                  if (postmartem.length > 0) {
                    setIsPostMartem(postmartem[0].isPostMartem);
                    setlabTestID(postmartem[0].labTestID);
                    setTestStatus(postmartem[0].testStatus);
                    setisThirdPartyLab(postmartem[0].isThirdPartyLab);
                    setthirdPartyNric(postmartem[0].thirdPartyNric);
                  }
                  return {
                    ...sample,
                    id: sample.id || index + 1,
                    rowId: sample.rowId || 0,
                    sampleCaseRowId: sample.rowId,
                    disableDelete: true,
                    labTERTestDetails: postmartem,
                  };
                }
              );
              if (isMetadata !== "1") {
                setSamplesAndTests(samplesAndTests);
                setOriginalSamplesAndTests(samplesAndTests);
              }
              samplesAndTests.forEach(async (sample, index) => {
                if (sample.species) {
                  await fetchBreedAndSpecimenOptions(index, sample.species);
                }
              });
              await Promise.all(samplesAndTests);
              setRejectedTestsMessage(
                generateRejectedTestsMessage(samplesAndTests)
              );
            }
          }
        }
      } catch (error) {
        console.error(ErrMsg.InternalServerErrMsg, error);
        message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
      } finally {
        setcheckPageLoader(false);
        localStorage.removeItem("ismetadata");
      }
    }
    if (!hasFetchedInitialData) {
      checkQueryString();
      setHasFetchedInitialData(true);
    }
  }, [clinicalHistoryOptions, hasFetchedInitialData]);

  const handleToggleFarmLocationDetails = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();

    setShowFarmLocationDetails(
      (prevshowFarmLocationDetails) => !showFarmLocationDetails
    );
  };

  const toggleVaccinationHistory = () => {
    setIsVaccinationHistoryExpanded((prev) => !prev);
  };

  const toggleQuarantineInfo = () => {
    setShowQuarantineInfo((prev) => !prev);
  };

  const [showSearchTestsModal, setShowSearchTestsModal] =
    useState<boolean>(false);
  useEffect(() => {
    const storedProfile = localStorage.getItem("profile-info");
    if (storedProfile) {
      setPersonalInfo(JSON.parse(storedProfile));
    }
  }, []);
  const validateForm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    let isValidAppDetils = true;
    let overAllValidFlag = true;
    let personalInfostorage: IPersonalInfo = { ...initialPersonalInfo };
    try {
      const storedProfileInfo = localStorage.getItem("profile-info");
      if (storedProfileInfo) {
        personalInfostorage = JSON.parse(storedProfileInfo);
      }
    } catch (error) {
      console.error("Error parsing profile-info from localStorage:", error);
    }

    if (!validDates) {
      overAllValidFlag = false;
      message(NotifyType.Error, "Please enter valid sampling date fields.");
    }
    let applicationDetailsManFields = Object.values(
      sampleDetailMandatoryFields
    );
    let tempApplicationDetails: any = TERSampleDetails;
    applicationDetailsManFields.forEach((x: any) => {
      let temp = tempApplicationDetails[x];
      if (typeof temp == "number") {
        if (!temp) {
          isValidAppDetils = false;
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidAppDetils = false;
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });
    fieldOptionPairs.forEach(({ field, option }) => {
      if (tempApplicationDetails[field] && !tempApplicationDetails[option]) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          [`${option}ErrMsg`]: `Please select an option for ${field}.`,
        };
      } else if (tempApplicationDetails[option]) {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          [`${option}ErrMsg`]: ``,
        };
      }
    });
    if (
      TERSampleDetails?.purposeOfTest === 4 ||
      TERSampleDetails?.purposeOfTest === 6
    ) {
      if (!TERSampleDetails?.referringVeterinarian?.length) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          referringVeterinarianErrMsg: "Please fill Veterinarian.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          referringVeterinarianErrMsg: ``,
        };
      }
    }
    if (TERSampleDetails?.purposeOfTest === 1) {
      if (!TERSampleDetails?.bioSurveillanceProgram?.length) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          bioSurveillanceProgramErrMsg:
            "Please select a Biosurveillance Program.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          bioSurveillanceProgramErrMsg: "",
        };
      }
    }
    if (TERSampleDetails?.purposeOfTest === 4) {
      if (!TERSampleDetails?.dateExportedDate) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          dateExportedDateErrMsg: "Please select Date to be exported.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          dateExportedDateErrMsg: "",
        };
      }

      if (!TERSampleDetails?.exportercountryOfDestination?.length) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          exportercountryOfDestinationErrMsg:
            "Please select Exporter Country of Destination.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          exportercountryOfDestinationErrMsg: "",
        };
      }
    } else {
      tempApplicationDetails = {
        ...tempApplicationDetails,
        exportercountryOfDestinationErrMsg: "",
        dateExportedDateErrMsg: "",
      };
    }
    setTERSampleDetails(tempApplicationDetails);
    if (!isValidAppDetils) {
      overAllValidFlag = false;
    }

    let isValidSampleAndTests = true;
    let manFieldsSampleAndTests = Object.values(SamplesAndTestMandatoryFields);
    const sampleMarkingsAll = samplesAndTests
      .map((s: any) => s.sampleMarking?.trim())
      .filter(Boolean);
    const duplicates = sampleMarkingsAll.filter(
      (mark, idx, arr) =>
        arr.indexOf(mark) !== idx && arr.lastIndexOf(mark) === idx
    );
    const newArray = samplesAndTests.map((item: any) => {
      manFieldsSampleAndTests.forEach((x: any) => {
        let temp = item[x];
        if (typeof temp == "number") {
          if (!temp) {
            isValidSampleAndTests = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        } else {
          if (!temp?.length) {
            isValidSampleAndTests = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        }
      });
      const trimmedMark = item.sampleMarking?.trim();
      if (!trimmedMark) {
        isValidSampleAndTests = false;
        item = { ...item, sampleMarkingErrMsg: "Please fill Sampling Marking" };
      } else if (duplicates.includes(trimmedMark)) {
        isValidSampleAndTests = false;
        item = {
          ...item,
          sampleMarkingErrMsg:
            "Sample Marking must be unique across all samples.",
        };
      } else {
        item = { ...item, sampleMarkingErrMsg: "" };
      }
      item.labTERTestDetails.forEach((testDetail: any) => {
        const isPostMortemTest =
          testDetail.testMethodSOPDescription?.trim().toLowerCase() ===
          "post-mortem";

        if (isPostMortemTest) {
          if (
            !item.postMortemConsentFormName ||
            item.postMortemConsentFormName.length === 0
          ) {
            isValidSampleAndTests = false;
            item = {
              ...item,
              postMortemConsentFormNameErrMsg:
                "Please fill Post-Mortem Consent Form.",
            };
          } else {
            item = { ...item, postMortemConsentFormNameErrMsg: "" };
          }

          if (!item.saveRemains) {
            isValidSampleAndTests = false;
            item = {
              ...item,
              saveRemainsErrMsg:
                "Please select Save Remains for Burial/Cremation.",
            };
          } else {
            item = { ...item, saveRemainsErrMsg: "" };
          }
        }
      });
      return item;
    });

    setSamplesAndTests(newArray);

    if (!isValidSampleAndTests) overAllValidFlag = false;
    let isValidPreferences = true;
    let preferenceFields = Object.values(PreferenceMandatoryFields);
    let tempPreferences: any = Preference;

    preferenceFields.forEach((x: any) => {
      let temp = tempPreferences[x];
      if (typeof temp === "number") {
        if (!temp) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });
    if (!Preference?.modeOfReceiving) {
      isValidPreferences = false;
      tempPreferences = {
        ...tempPreferences,
        modeOfReceivingErrMsg: "Please select Mode of Receiving.",
      };
    } else {
      tempPreferences = { ...tempPreferences, modeOfReceivingErrMsg: "" };

      if (Preference.modeOfReceiving === 1) {
        if (!Preference?.mailingAddress) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            mailingAddressErrMsg: "Please select the mailing address.",
          };
        } else if (
          Preference.mailingAddress === 3 &&
          !Preference?.customAddress?.length
        ) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            customAddressErrMsg: "Please enter the custom address.",
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            mailingAddressErrMsg: "",
            customAddressErrMsg: "",
          };
        }

        if (!Preference?.acknowledge) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            acknowledgeErrMsg: "You must acknowledge before proceeding.",
          };
        } else {
          tempPreferences = { ...tempPreferences, acknowledgeErrMsg: "" };
        }
      }
    }

    setPreference(tempPreferences);

    if (personalInfostorage) {
      if (!personalInfostorage?.address?.streetName?.trim()) {
        isValidPreferences = false;
        message(
          NotifyType.Error,
          "Please fill the mailing address street name fields."
        );
      }
      if (!personalInfostorage?.address?.postalCode?.trim()) {
        isValidPreferences = false;
        message(
          NotifyType.Error,
          "Please fill the mailing address postal code fields."
        );
      }

      if (!personalInfostorage?.contact?.salutation) {
        isValidPreferences = false;
        message(NotifyType.Error, "Please fill Salutation.");
      }
      if (!personalInfostorage?.contact?.email) {
        isValidPreferences = false;
        message(NotifyType.Error, "Please fill Email.");
      }
    }

    if (!isValidPreferences) overAllValidFlag = false;

    if (overAllValidFlag) {
      handleNextClick();
    } else {
      message(NotifyType.Error, "Please fill the mandatory fields.");
    }
  };

  const handlepostmartemFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    sampleIndex: number
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const filesArray = Array.from(event.target.files);
      const fileObjects: PostMortemConsentForm[] = await Promise.all(
        filesArray.map(async (file) => {
          const base64 = await fileToBase64(file);
          return {
            ID: "",
            postMortemConsentFormName: file.name,
            postMortemConsentForm: base64,
          };
        })
      );

      const fileNames = filesArray.map((file) => file.name);
      setSamplesAndTests((prevState) => {
        const updatedSamplesAndTests = [...prevState];
        const existingForms =
          updatedSamplesAndTests[sampleIndex]?.postMortemConsentForms || [];
        const existingFormNames =
          updatedSamplesAndTests[sampleIndex]?.postMortemConsentFormName || "";
        updatedSamplesAndTests[sampleIndex] = {
          ...updatedSamplesAndTests[sampleIndex],
          postMortemConsentForms: [
            ...(Array.isArray(existingForms) ? existingForms : []),
            ...fileObjects,
          ],
          postMortemConsentFormName: existingFormNames
            ? `${existingFormNames}, ${fileNames.join(", ")}`
            : fileNames.join(", "),
        };

        return updatedSamplesAndTests;
      });
    }
  };
  const handledFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      let filesArray = Array.from(event.target.files);
      let documentsArray: { ID: string; Name: string; Attachment: string }[] =
        [];

      for (let file of filesArray) {
        const base64String = await fileToBase64(file);
        if (base64String.length) {
          documentsArray.push({
            ID: "",
            Name: file.name,
            Attachment: base64String,
          });
        }
      }

      if (documentsArray.length) {
        setPreference((prevState) => {
          return {
            ...prevState,
            supportDocuments: [
              ...(prevState.supportDocuments || []),
              ...documentsArray,
            ],
            supportDocumentName: [
              ...(prevState.supportDocumentName
                ? prevState.supportDocumentName.split(", ")
                : []),
              ...documentsArray.map((doc) => doc.Name),
            ].join(", "),
          } as typeof Preference;
        });
      }
    }
  };

  const handleRemoveFile = (fileName: string) => {
    setPreference((prevState) => {
      const fileIndex = prevState.supportDocumentName
        ?.split(", ")
        .indexOf(fileName);
      if (fileIndex === -1) return prevState;
      const updatedSupportDocuments = prevState.supportDocuments?.filter(
        (_, index) => index !== fileIndex
      );
      const updatedSupportDocumentNames = prevState.supportDocumentName
        ?.split(", ")
        .filter((_, index) => index !== fileIndex)
        .join(", ");
      return {
        ...prevState,
        supportDocuments: updatedSupportDocuments,
        supportDocumentName: updatedSupportDocumentNames,
      };
    });
  };
  const handledCopyButtonClick = (
    sampleIndex: number,
    testLabTestID: string,
    resultIndex: number
  ) => {
    setSamplesAndTests((prevSamplesAndTests) => {
      const updatedSamplesAndTests = prevSamplesAndTests.map((sample) => {
        const updatedLabTERTestDetails = sample.labTERTestDetails.map(
          (test) => {
            if (test.labTestID === testLabTestID) {
              const labTERTestResult = Array.isArray(test.labTERTestResult)
                ? test.labTERTestResult
                : [];
              const valueToCopy = labTERTestResult[resultIndex]
                ? { ...labTERTestResult[resultIndex] }
                : defaultTestResult;

              const updatedLabTERTestResult = [
                ...labTERTestResult,
                valueToCopy,
              ];

              return {
                ...test,
                labTERTestResult: updatedLabTERTestResult,
              };
            }
            return test;
          }
        );

        if (
          sample.labTERTestDetails.some(
            (test) => test.labTestID === testLabTestID
          )
        ) {
        }

        return {
          ...sample,
          labTERTestDetails: updatedLabTERTestDetails,
        };
      });

      return updatedSamplesAndTests;
    });
  };

  const handledSamplesAndTestsChange =
    (
      altIndex: number,
      type: string,
      testLabTestID: string,
      resultIndex: number
    ) =>
    (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >
    ) => {
      let newValue: boolean | number | string | undefined;
      if (type === "decimal") {
        newValue = Math.max(0, parseFloat(e.target.value));
      } else if (type === "number") {
        newValue = Math.max(0, parseInt(e.target.value));
      } else if (type === "date") {
        newValue = moment(e.target.value, "YYYY-MM-DD").toISOString();
      } else {
        newValue = e.target.value;
      }

      setSamplesAndTests((prevSamples) => {
        const updatedSamples = prevSamples.map((item) => {
          const updatedLabTERTestDetails = item.labTERTestDetails.map(
            (test) => {
              if (test.labTestID === testLabTestID) {
                const updatedLabTERTestResult = (
                  test.labTERTestResult && test.labTERTestResult.length > 0
                    ? test.labTERTestResult
                    : [defaultTestResult]
                ).map((result, k) => {
                  if (k === resultIndex) {
                    return {
                      ...result,
                      [e.target.name]: newValue,
                    };
                  } else {
                    return result;
                  }
                });

                return {
                  ...test,
                  labTERTestResult: updatedLabTERTestResult,
                };
              } else {
                return test;
              }
            }
          );

          return {
            ...item,
            labTERTestDetails: updatedLabTERTestDetails,
          };
        });

        return updatedSamples;
      });
    };

  const handleSelectChange =
    (index: number, name: string) =>
    async (selectedOption: IReactSelectOption | null) => {
      setSamplesAndTests((prevSamples) => {
        const updatedSamples = [...prevSamples];
        const updatedSample = { ...updatedSamples[index] };

        if (name === "species") {
          updatedSample.species = selectedOption ? selectedOption.value : "";
          updatedSample.speciesErrMsg = ""; // Clear species error message
          updatedSample.breed = "";
          updatedSample.breedErrMsg = "";
          updatedSample.specimenDescription = "";
          updatedSample.specimenDescriptionErrMsg = "";
          updatedSample.otherSpecies = "";
          updatedSample.otherBreed = "";
          updatedSample.otherSpecimenDescription = "";
          updatedSample.breedOptions = [];
          updatedSample.specimenOptions = [];
          updatedSamples[index] = updatedSample;
          if (selectedOption) {
            fetchBreedAndSpecimenOptions(index, selectedOption.value);
          }
        } else if (name === "breed") {
          updatedSample.breed = selectedOption ? selectedOption.value : "";
          updatedSample.breedErrMsg = ""; // Clear breed error message
        } else if (name === "specimenDescription") {
          updatedSample.specimenDescription = selectedOption ? selectedOption.value : "";
          updatedSample.specimenDescriptionErrMsg = ""; // Clear specimen description error message
        } else if (name === "countryofResidence") {
          updatedSample.countryofResidence = selectedOption ? selectedOption.value : "";
        }

        updatedSamples[index] = updatedSample;
        return updatedSamples;
      });
    };

  const fetchBreedAndSpecimenOptions = async (
    index: number,
    species: string
  ) => {
    const breedSpecimensResponse = await getBreedSpecimenBySpecies(species);
    if (breedSpecimensResponse.status === 200) {
      const { labBreed, labSpecimen } = breedSpecimensResponse.data;
      setSamplesAndTests((prevSamples) => {
        const updatedSamples = [...prevSamples];
        const updatedSample = { ...updatedSamples[index] };

        updatedSample.breedOptions =
          labBreed?.map((breed: any) => ({
            value: breed.breedName,
            label: breed.breedName,
          })) || [];

        updatedSample.specimenOptions =
          labSpecimen?.map((specimen: any) => ({
            value: specimen.labSpecimenDescription,
            label: specimen.labSpecimenDescription,
          })) || [];

        updatedSamples[index] = updatedSample;
        return updatedSamples;
      });
    }
  };

  const handledSelectChange =
    (index: number, name: string, testIndex: string, resultIndex: number) =>
    (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      };
      handledSamplesAndTestsChange(
        index,
        "string",
        testIndex,
        resultIndex
      )(event as any);
    };

  const handleSaveDraftClick = async () => {
    try {
      handleLoader(true, "submit-req");
      const hasEmptyTests = samplesAndTests.some(
        (sample) =>
          !sample.labTERTestDetails || sample.labTERTestDetails.length === 0
      );

      if (hasEmptyTests) {
        message(NotifyType.Error, "Please add Test Information.");
        handleLoader(false, "submit-req");
        return;
      }
      let chooseAppMeta: IChooseApp = {
        typeOfApplication: "TER",
        typeOfService: "CAVS Laboratory Services",
        applicationType: 0,
      };

      const filerInfo: IFilerInformation | null = getFilerInfomation();
      let personalInfo: IPersonalInfo = JSON.parse(
        localStorage.getItem("profile-info") || ""
      );
      const meta: ITERRequest = {
        labTERPersonalInfoDetails: personalInfo,
        labTERChooseApplDetails: chooseAppMeta,
        labTERApplicationDetails: {
          ...TERSampleDetails,
        } as ITERSampleDetails,
        applicationNumber: applicationNum,
        labTERSampleTests: samplesAndTests.map((sample) => {
          return {
            ...sample,
            labTERTestDetails: sample.labTERTestDetails.map((test: any) => ({
              ...test,
              testDescription: stripHtmlTags(test.testDescription),
            })),
          };
        }),
        labTERPreference: Preference,

        labTERFilerInfoDetails: filerInfo || tempFilerInfo,
      };

      if (actionType === TypeOfApplicationEnum.submit) {
        delete meta.applicationNumber;
      }
      const response1 = await SaveTERDraftApplications(meta);

      if (response1.status === 200) {
        const acknowledgmentNumberMatch = response1.data.match(
          /CAVS_TERApplicationNumber:\s*([A-Z0-9]+)/
        );

        const acknowledgmentNumber = acknowledgmentNumberMatch
          ? acknowledgmentNumberMatch[1]
          : undefined;
        setApplicationNum(acknowledgmentNumber || "");
        if (actionType === TypeOfApplicationEnum.submit) {
          setActionType("Draft");
        }
        message(
          NotifyType.Success,
          acknowledgmentNumber
            ? `Draft Saved Successfully`
            : "Draft Saved Successfully"
        );
        setAcknowledgmentMessage(
          acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
        );

        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleLoader(false, "submit-req");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };
  useEffect(() => {
    if (speciesOptions) {
      const speciesOpts = speciesOptions.map((species) => ({
        label: species.speciesName,
        value: species.speciesName,
      }));
      setSpeciesSelectOptions(speciesOpts);
    }
  }, [speciesOptions]);

  const cancelRequest = async () => {
    try {
      setCancelCommentsErrMsg("");
      if (cancelComments) {
        handleLoader(true, "cancel-request-btn");

        let chooseAppMeta: IChooseApp = {
          typeOfApplication: "TER",
          typeOfService: "CAVS Laboratory Services",
          applicationType: 0,
        };

        const applicationNum: string = params.get("an") ?? "";
        const filerInfo: IFilerInformation | null = getFilerInfomation();
        let personalInfo: IPersonalInfo = JSON.parse(
          localStorage.getItem("profile-info") || ""
        );
        const meta: ITERRequest = {
          labTERPersonalInfoDetails: personalInfo,
          labTERChooseApplDetails: chooseAppMeta,
          labTERApplicationDetails: {
            ...TERSampleDetails,
          } as ITERApplicationDetails,
          labTERSampleTests: samplesAndTests,
          applicationNumber: applicationNum,
          labTERApplicationStatus: defTERCancelAppStatus,
          labTERPreference: Preference,
          labTERFilerInfoDetails: filerInfo || tempFilerInfo,
        };

        let response1 = await saveTERCancellation(meta);
        if (response1.status === 200) {
          const acknowledgmentNumberMatch = response1.data?.match(
            /"CAVS_AQUACancelApplicationNumber ":"(\w+)"/
          );

          const acknowledgmentNumber = acknowledgmentNumberMatch
            ? acknowledgmentNumberMatch[1]
            : undefined;

          message(
            NotifyType.Success,
            `Cancellation Request Submitted Successfully. Acknowledgment Number: ${acknowledgmentNumber}`
          );
          setcancelMessage(
            acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
          );

          localStorage.removeItem("choose-app");
          setCancelButtonHidden(true);
          setTimeout(() => {
            navigate("/lab-dashboard", { state: { acknowledgmentNumber } });
          }, 3000);
        } else {
          message(NotifyType.Error, "Issue on the request submission.");
        }
      } else {
        setCancelCommentsErrMsg("Please fill Cancellation Comments");
        message(NotifyType.Error, "Please fill the mandatory fields.");
      }
      handleLoader(false, "cancel-request-btn");
    } catch (ex) {
      console.error(ex);
      handleLoader(false, "cancel-request-btn");
    }
  };

  const handleAddSample = () => {
    setSamplesAndTests((prevSamples) => {
      const newSample = {
        ...samplesAndTestSchema,
        id: Date.now(),
        labTERTestDetails: [],
      };
      return [...prevSamples, newSample];
    });
  };

  const handleDeleteSample = (sampleId: number | undefined) => {
    setSamplesAndTests((samples) => {
      if (samples.length > 1) {
        return samples.filter((sample) => sample.id !== sampleId);
      }
      return samples;
    });
  };

  const handleCopySample = (sampleInd: number, times: number) => {
    const sample = samplesAndTests[sampleInd];

    setSamplesAndTests((prevSamples) => {
      const newSamples = Array.from({ length: times }, () => {
        const newSample = {
          ...sample,
          id: Date.now() + Math.random(),
          disableDelete: false,
          labTERTestDetails: sample?.labTERTestDetails?.map((obj: any) => ({
            ...obj,
            disableDelete: false,
          })),
        };
        if (newSample.hasOwnProperty("rowId")) {
          delete newSample.rowId;
        }

        return newSample;
      });

      return [...prevSamples, ...newSamples];
    });
  };
  const handleToggleFarmDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setShowFarmDetails((prevShowFarmDetails) => !prevShowFarmDetails);
  };

  const handleMyPreference = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    type: string
  ) => {
    setPreference((prevState) => {
      const target = e.target as HTMLInputElement;
      let value: string | boolean | number = target.value;

      switch (type) {
        case "radio":
          value = parseInt(target.value, 10);
          break;
        case "number":
          value = target.value ? parseInt(target.value, 10) : 1;
          break;
        case "checkbox":
          value = target.checked;
          break;
        default:
          break;
      }

      return {
        ...prevState,
        [target.name]: value,
      } as IlabTERPreference;
    });
  };

  const handlePreviousClick = () => {
    if (
      IsAcknowledgeRequest ||
      isCancelRequest ||
      IsSubmitresultRequest ||
      IsAcknowledge ||
      amendCase
    ) {
      navigate("/lab-dashboard");
    } else {
      navigate("/choose-application");
    }
  };
  const handledPreviousClick = () => {
    navigate("/labresults-dashboard");
  };
  const fetchLabTestOptions = async () => {
    try {
      const labMastersResponse: any = await getPshCavsTestCodeMaster({
        PurposeCode: "TER",
        IsBiosurvillanceUser: IsBiosurvillanceUser,
      });
      const labMastersData = labMastersResponse.data;
      const labTestOptions = labMastersData.cavsLabMasters.map((item: any) => ({
        labGroupId: item.labGroupId,
        labGroup: item.labGroup,
      }));

      setlabtestoptions(labTestOptions);
    } catch (error) {
      console.error("Error fetching lab test options:", error);
    }
  };

  useEffect(() => {
    fetchLabTestOptions();
  }, []);
  useEffect(() => {
    setlabtestoptions([]);
  }, []);

  const handleShowSearchTestsModal = (index: number) => {
    setSearchInd(index);
    setShowSearchTestsModal(true);
  };
  let samplesAndTestSchema: ITERSamplesAndTests = {
    id: Date.now(),
    sampleMarking: "",
    species: "",
    noOfSamples: 1,
    breed: "",
    specimenDescription: "",
    labTERTestDetails: [],
    noOnPremises: 0,
    noInGroup: 0,
    noSick: 0,
    noDead: 0,
    noAtRisk: 0,
    sterilized: 0,
    groupID: "",
    penNo: "",
    longitude: "",
    latitude: "",
    owner: "",
    microchipNo: "",
    gender: "",
    nameofAnimal: "",
    years: 0,
    months: 0,
    remarks: "",
    animalStatus: null,
    saveRemains: "",
    methodofEuthanised: "",
    euthanisedDate: null,
    euthanised: false,
    weeks: 0,
    dateofBirth: null,
    countryofResidence: "",
  };
  const calculateAge = (dateofBirth: string) => {
    const now = moment();
    const birthDate = moment(dateofBirth, "YYYY-MM-DD");

    const years = now.diff(birthDate, "years");
    birthDate.add(years, "years");

    const months = now.diff(birthDate, "months");
    birthDate.add(months, "months");

    const weeks = now.diff(birthDate, "weeks");

    return { years, months, weeks };
  };
  const handleSamplesAndTestsChange =
    (index: number, type: string) =>
    (
      e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
      let newValue: boolean | number | string | undefined;

      if (type === "number") {
        newValue = Math.max(0, parseInt(e.target.value));
      } else if (type === "date") {
        newValue = moment(e.target.value, "YYYY-MM-DD").toISOString();
      } else if (type === "radio") {
        newValue = e.target.value;
      } else if (type === "checkbox") {
        newValue = (e as ChangeEvent<HTMLInputElement>).target.checked;
      } else {
        newValue = e.target.value;
      }

      const newArray = samplesAndTests.map((item: ITERSamplesAndTests, i) => {
        if (index === i) {
          const updatedItem = {
            ...item,
            [e.target.name.replace(`-${index}`, "")]: newValue,
          };

          if (e.target.name === "dateofBirth") {
            const age = calculateAge(e.target.value);
            updatedItem.years = age.years;
            updatedItem.months = age.months;
            updatedItem.weeks = age.weeks;
          }

          return updatedItem;
        } else {
          return item;
        }
      });

      setSamplesAndTests(newArray);
    };

  const { TERMeta } = useContext(TERMetaContext);
  const [TERSampleDetails, setTERSampleDetails] = useState<ITERSampleDetails>({
    id: Date.now(),
    purposeOfTest: 0,
    crossReference: "",
    otherPurposeOfTest: "",
    countryofBirth: "",
    referringVeterinarian: "",
    samplingFromDate: null,
    samplingToDate: null,
    sampledBy: "",
    courierName: "",
    latitude: "",
    longitude: "",
    farmLocationName: "",
    farmCode: "",
    addressType: "",
    postalCode: "",
    specialFarmCode: "",
    roadName: "",
    houseNo: "",
    level: "",
    unitNo: "",
    buildingName: "",
    cityName: "",
    state: "",
    country: "",
    history_Remarks: "",
    healthy: 0,
    totalNoonPremises: 0,
    farmArea: 0,
    ageAffected: 0,
    diseaseStartedon: null,
    ago: 0,
    pattern: 0,
    noDiseased: 0,
    unitsizeoptions: 0,
    noAfffected: 0,
    yearsmonth: 0,
    noOrDiseasedOptions: 0,
    noDeadDaily: 0,
    totalNoDead: 0,
    totalNoofunits: 0,
    noOfUnitsOptions: 0,
    unitSize: 0,
    farmAreaOptions: 0,
    ageAffectedOptions: 0,
    sizeAffected: 0,
    otherSpeciesAffected: "",
    clinicalSigns: "",
    clinicalManagement: "",
    vaccinationHistory: "",
    importLicenseNo: "",
    toBeExported: false,
    dateExportedDate: null,
    inQuarantine: false,
    samplesCollectedOrSubmitted: "Tobesubmitted",
    courierTrackingNo: "",
    exportercountryOfDestination: "",
    bioSurveillanceProgram: "",
  });
  const defaultTestResult: ITestResult = {
    resultcode: "",
    Readings: 0,
    Readings2: 0,
    Symbol1: 0,
    Symbol2: 0,
    Positive: "",
    Negative: "",
    Indefinite: "",
    ResultRemarks: "",
    report: "",
    Parasitology: "",
    Microbiology: "",
    Histopathology: "",
    ourreference: "",
    finalDiagnosis: "",
    resultcodeErrMsg: "",
    testingInstructions: "",
    remarksForThirdParty: "",
    units: "",
  };
  const mergeWithDefaults = (result: any) => ({
    ...defaultTestResult,
    ...result,
  });

  const [postalCode, setpostalCode] = useState({
    postalCode: "",
    roadName: "",
    houseNo: "",
    buildingName: "",
    CityName: "",
    state: "",
    unitNo: "",
  });
  useEffect(() => {
    if (TERSampleDetails?.farmCode) {
      const fetchPremiseDetails = async () => {
        try {
          const response = await PremiseCodeDetails(TERSampleDetails?.farmCode);

          setTERSampleDetails((prevDetails) => ({
            ...prevDetails,
            postalCode: response.data.postalCode || "",
            roadName: response.data.streetRoadName || "",
            houseNo: response.data.blockHouseNumber || "",
            buildingName: response.data.buildingName || "",
            farmLocationName: response.data.premisesName || "",
            country: response.data.country || "",
            level: response.data.floorNumber || "",
            unitNo: response.data.unitNumber || "",
            cityName: response.data.districtCity || "",
            state: response.data.stateProvince || "",
            addressType:
              response.data.country === "Singapore" ? "Local" : "Foreign",
          }));
        } catch (error) {
          console.error("Failed to fetch premise details", error);
        }
      };

      fetchPremiseDetails();
    } else {
      setTERSampleDetails((prevDetails) => ({
        ...prevDetails,
        postalCode: "",
        roadName: "",
        houseNo: "",
        buildingName: "",
        farmLocationName: "",
        country: "",
      }));
    }
  }, [TERSampleDetails?.farmCode]);
  const fetchData = async (addressType: string) => {
    try {
      if (!postalCode.postalCode || addressType !== "Local") {
        return;
      }

      const encodedPostalCode = encodeURIComponent(postalCode.postalCode);
      const apiUrl = `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${encodedPostalCode}&returnGeom=N&getAddrDetails=Y&pageNum=1`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.found > 0) {
        const { ROAD_NAME, BLK_NO, BUILDING } = data.results[0];

        setTERSampleDetails((prevDetails) => ({
          ...prevDetails,
          postalCode: postalCode.postalCode,
          roadName: ROAD_NAME,
          houseNo: BLK_NO,
          buildingName: BUILDING,
        }));
      } else {
        setTERSampleDetails((prevDetails) => ({
          ...prevDetails,
          postalCode: postalCode.postalCode,
          roadName: "",
          houseNo: "",
          buildingName: "",
        }));
      }
    } catch (error) {
      setTERSampleDetails((prevDetails) => ({
        ...prevDetails,
        postalCode: postalCode.postalCode,
        roadName: "",
        houseNo: "",
        buildingName: "",
      }));
    }
  };
  const handleCloseSearchTestsModal = () => {
    setShowSearchTestsModal(false);
  };
  const validateSamplesAndTests = (
    samplesAndTests: any[],
    customerNRIC: string
  ) => {
    let isValidSampleAndTests = true;
    let missingFields: string[] = [];

    const validatedSamples = samplesAndTests.map((item: any) => {
      const filteredTests =
        item.labTERTestDetails?.filter((test: any) => {
          const isValidTest =
            test.isThirdPartyLab === 1 &&
            test.thirdPartyNric === customerNRIC &&
            test.rowId === testRowId &&
            (test.testStatus === null || test.testStatus !== 8);
          return isValidTest;
        }) || [];

      filteredTests.forEach((test: any) => {
        const isPostMartem = test.isPostMartem === 1;

        const fieldsToValidate = isPostMartem
          ? postMartemFields
          : Object.values(ResultMandatoryFields);

        if (test.labTERTestResult && test.labTERTestResult.length > 0) {
          test.labTERTestResult = test.labTERTestResult.map(
            (result: any, resultIndex: number) => {
              let isValidResult = true;

              fieldsToValidate.forEach((field) => {
                const fieldValue = result[field];

                if (
                  fieldValue === undefined ||
                  fieldValue === null ||
                  fieldValue === ""
                ) {
                  isValidSampleAndTests = false;
                  isValidResult = false;
                  missingFields.push(field);

                  result = {
                    ...result,
                    [`${field}ErrMsg`]: `Please fill ${field}.`,
                  };
                } else {
                  result = {
                    ...result,
                    [`${field}ErrMsg`]: "",
                  };
                }
              });

              return result;
            }
          );
        }
      });

      return item;
    });

    return { isValidSampleAndTests, validatedSamples, missingFields };
  };
  const handledSaveResultClick = async () => {
    try {
      handleLoader(true, "submit-req");

      const { isValidSampleAndTests, validatedSamples, missingFields } =
        validateSamplesAndTests(samplesAndTests, customerNRIC);

      if (!isValidSampleAndTests) {
        setSamplesAndTests(validatedSamples);
        message(NotifyType.Error, "Please fill the mandatory fields.");
        handleLoader(false, "");
        return;
      }

      const applicationNum = params.get("an") ?? "";
      const dataToSubmit = {
        applicationNumber: applicationNum,
        labResultRequests: samplesAndTests.flatMap((sample) =>
          sample.labTERTestDetails
            .filter((test) => {
              const isValidTest =
                test.isThirdPartyLab === 1 &&
                test.thirdPartyNric === customerNRIC &&
                test.rowId === testRowId &&
                (test.testStatus === null || test.testStatus !== 8);

              return test.testDescription !== "" && isValidTest;
            })
            .flatMap((test) =>
              (test.labTERTestResult ?? []).map((result, resultIndex) => ({
                labTestID: test.labTestID,
                testDescription: stripHtmlTags(test.testDescription),
                ResultDocuments: test.ResultDocuments ?? [],
                ResultDocumentName: test.ResultDocumentName ?? "",
                isAdditionalResult: resultIndex === 0 ? 0 : 1,
                ...mergeWithDefaults(result),
              }))
            )
        ),
      };

      const response = await saveResultRequest(dataToSubmit);

      if (response?.status === 200) {
        message(NotifyType.Success, "Results Saved Successfully");
        localStorage.removeItem("psh-app-applicationNum");
        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const handleACKResultClick = async () => {
    try {
      handleLoader(true, "submit-req");
      const newArray = samplesAndTests.map((sample: any) => {
        sample.labTERTestDetails.forEach((test: any) => {
          delete test.labTERTestResult;
        });
        return sample;
      });
      setSamplesAndTests(newArray);
      const applicationNum = params.get("an") ?? "";
      const dataToSubmit = {
        applicationNumber: applicationNum,
        labResultRequests: samplesAndTests.flatMap((sample) =>
          sample.labTERTestDetails
            .filter(
              (test) =>
                test.testDescription !== "" &&
                test.isThirdPartyLab === 1 &&
                test.rowId === testRowId &&
                test.thirdPartyNric === customerNRIC &&
                test.testStatus !== 8
            )
            .map((test) => ({
              labTestID: test.labTestID,
              testDescription: test.testDescription,
              laboratory: test.laboratory,
              TestStatus: 7,
            }))
        ),
      };
      if (dataToSubmit.labResultRequests.length === 0) {
        message(NotifyType.Warning, "No tests available for submission.");
        return;
      }

      const response = await saveAckRequest(dataToSubmit);
      if (response?.status === 200) {
        message(NotifyType.Success, "Request Saved Successfully");
        localStorage.removeItem("psh-app-applicationNum");
        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("type", "submitresult");
        window.location.href = currentUrl.toString();
      } else {
        message(NotifyType.Error, "Issue with the request submission.");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const stepWizardConfig: IStepwizardProps = {
    currentStep: 2,
    steps: [
      {
        name: "Choose Application",
      },

      {
        name: "Samples & Tests",
      },
      {
        name: "Review",
      },
      {
        name: "Cost & Confirm",
      },
      {
        name: "Acknowledgement",
      },
    ],
  };

  let chooseApp: string | null = localStorage.getItem("choose-app");
  let chooseAppMeta: IChooseApp = {
    typeOfApplication: "TER",
    typeOfService: chooseApp || "",
    applicationType: 0,
  };

  if (chooseApp && chooseApp.length) {
    let parsedChooseApp: IChooseApp = JSON.parse(chooseApp);
    chooseAppMeta = {
      ...chooseAppMeta,
      ...parsedChooseApp,
      typeOfApplication: "TER",
    };
  }

  const filerInfo: IFilerInformation | null = getFilerInfomation();
  function getModifiedValues<T>(original: T, current: T): Partial<T> {
    const modified: Partial<T> = {};
    for (const key in current) {
      if (current[key] !== original[key]) {
        modified[key] = current[key];
      }
    }
    return modified;
  }
  function getModifiedPreference(
    original: IlabTERPreference,
    current: IlabTERPreference
  ): IlabTERPreference | undefined {
    const modified: Partial<IlabTERPreference> = {};

    for (const key in current) {
      if (
        JSON.stringify(original[key as keyof IlabTERPreference]) !==
        JSON.stringify(current[key as keyof IlabTERPreference])
      ) {
        modified[key as keyof IlabTERPreference] =
          current[key as keyof IlabTERPreference];
      }
    }
    if (Object.keys(modified).length === 0) {
      return undefined;
    }
    return modified as IlabTERPreference;
  }
  function getModifiedSamplesAndTests(
    original: ITERSamplesAndTests[],
    current: ITERSamplesAndTests[]
  ) {
    return current
      .map((currentItem, index) => {
        const originalItem = original[index];
        const modifiedItem: any = {};
        if (currentItem.sampleCaseRowId !== originalItem?.sampleCaseRowId) {
          modifiedItem.sampleCaseRowId = currentItem.sampleCaseRowId;
        }
        Object.keys(currentItem).forEach((key) => {
          const currentValue = currentItem[key];
          const originalValue = originalItem ? originalItem[key] : undefined;
          if (currentValue !== originalValue) {
            modifiedItem[key] = currentValue;
          }
        });
        return Object.keys(modifiedItem).length > 0 ? modifiedItem : null;
      })
      .filter((item) => item !== null);
  }
  const getTERRequestSchema = async (): Promise<ITERRequest> => {
    delete (TERSampleDetails as any)?.id;
    delete (TERSampleDetails as any)?.countryofBirthErrMsg;
    delete (TERSampleDetails as any)?.samplesCollectedOrSubmittedErrMsg;
    delete (TERSampleDetails as any)?.purposeOfTestErrMsg;
    delete (TERSampleDetails as any)?.healthyErrMsg;
    delete (TERSampleDetails as any)?.samplingFromDateErrMsg;
    delete (TERSampleDetails as any)?.samplingToDateErrMsg;
    delete (TERSampleDetails as any)?.sampledByErrMsg;
    delete (TERSampleDetails as any)?.bioSurveillanceProgramErrMsg;
    let sampleRowId = 1;
    const updatedSamples = samplesAndTests.map((sample) => {
      let testRowId = 1;
      const updatedSample = {
        ...sample,
        rowId: sampleRowId,
        sampleRowId: sampleRowId++,
        labTERTestDetails: sample.labTERTestDetails?.map((test) => ({
          ...test,
          rowId: testRowId,
          testRowId: testRowId++,
        })),
      };
      return updatedSample;
    });

    let personalInfo: IPersonalInfo = JSON.parse(
      localStorage.getItem("profile-info") || ""
    );
    const modifiedBioDetails = originalSampleDetails
      ? getModifiedValues(originalSampleDetails, TERSampleDetails)
      : TERSampleDetails;
    const modifiedSamplesAndTests = getModifiedSamplesAndTests(
      originalSamplesAndTests,
      samplesAndTests
    );
    const modifiedPreference = getModifiedPreference(
      originalPreference,
      Preference
    );
    return new Promise((resolve, reject) => {
      if (personalInfo && chooseAppMeta) {
        const filerInfo: IFilerInformation | null = getFilerInfomation();
        const meta: ITERRequest = {
          labTERPersonalInfoDetails: personalInfo,
          labTERChooseApplDetails: chooseAppMeta,
          labTERApplicationDetails: TERSampleDetails as ITERSampleDetails,
          labTERSampleTests: updatedSamples,
          labTERPreference: Preference,
          labApplicationchangedDetails: modifiedBioDetails as ITERSampleDetails,
          labchangedSampleTestDetails: modifiedSamplesAndTests,
          labChangedPreference: modifiedPreference,
          labTERFilerInfoDetails: filerInfo || tempFilerInfo,
          actionStatus: actionType || "",
        };
        if (meta.actionStatus !== TypeOfApplicationEnum.submit) {
          meta.applicationNumber = applicationNum || "";
        }

        if (meta.labTERSampleTests) {
          const maxSampleRowId = meta.labTERSampleTests.reduce(
            (maxId, sample) => {
              const rowId = typeof sample.rowId === "number" ? sample.rowId : 0;
              return Math.max(maxId, rowId);
            },
            0
          );

          let sampleRowId = maxSampleRowId + 1;
          meta.labTERSampleTests.forEach((v: any) => {
            v.rowId = v.rowId || sampleRowId++;
            delete v?.id;
            delete v?.labTERTestDetailsErrMsg;
            delete v?.specimenDescriptionErrMsg;
            delete v?.samplingFromDateErrMsg;
            delete v?.samplingToDateErrMsg;
            delete v?.sampleMarkingErrMsg;
            delete v?.speciesErrMsg;
            delete v?.breedErrMsg;
            delete v?.disableDelete;
            delete v?.saveRemainsErrMsg;
            delete v?.postMortemConsentFormNameErrMsg;

            let testRowId = 1;
            v?.labTERTestDetails?.forEach((element: any) => {
              delete element?.disableDelete;
              element.rowId = element.rowId || testRowId++;
            });
          });

          resolve(meta);
        } else {
          console.error("labTERSampleTests is null or undefined");
          reject(new Error("labTERSampleTests is null or undefined"));
        }
      } else {
        console.error("personalInfo or chooseApp is null or undefined");
        reject(new Error("personalInfo or chooseApp is null or undefined"));
      }
    });
  };

  const handleCopyButtonClick = (index: number) => {
    handleCopySample(index, copyCount || 1);
  };

  const handleCopyInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCopyCount(Number(event.target.value));
  };
  const storeInContext = async () => {
    try {
      let meta: ITERRequest = await getTERRequestSchema();

      TERMeta.updateTERMeta(meta);
    } catch (error) {
      console.error(error);
    }
  };

  const handleNextClick = async () => {
    storeInContext();
    setFormSubmitted(true);
    handleLoader(true, "next-click");
    try {
      await getTERRequestSchema();
      localStorage.removeItem("ismetadata");
      navigate("/ter-review");
    } catch (error) {
      console.error("Error:", error);
      message(NotifyType.Error, "An error occurred. Please try again.");
    } finally {
      handleLoader(false, "next-click");
    }
  };

  const handleTERSampleDetails = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    type: string
  ) => {
    let name = e.target.name;
    let value: any = e.target.value;
    if (type === "radio" && name === "animalStatus") {
      value = value === "alive" ? 1 : 2;
    }
    if (type === "radio") {
      if ((e.target as HTMLInputElement).checked) {
        setAddressType(value);
        if (name === "addressType" && value === "Local") {
          fetchData(value);
          setTERSampleDetails((prevState) => ({
            ...prevState,
            [name]: value,
            country: "Singapore",
          }));
          return;
        } else if (name === "addressType" && value === "Foreign") {
          setTERSampleDetails((prevState) => ({
            ...prevState,
            [name]: value,
            country: "",
            postalCode: "",
            roadName: "",
            houseNo: "",
            level: "",
            unitNo: "",
            buildingName: "",
            cityName: "",
            state: "",
          }));
          return;
        }
      }
    } else if (type === "checkbox") {
      value = (e.target as HTMLInputElement).checked;
    } else if (type === "number") {
      value = Math.max(0, parseInt(value));
    } else if (type === "date") {
      value =
        value.trim() === "" ? null : moment(value, "YYYY-MM-DD").toISOString();
    }

    setTERSampleDetails((prevState) => {
      const newDetails = {
        ...prevState,
        [name]: value,
      } as ITERSampleDetails;

      let validDates = true;
      if (newDetails.samplingFromDate && newDetails.samplingToDate) {
        const fromDate = moment(newDetails.samplingFromDate);
        const toDate = moment(newDetails.samplingToDate);

        if (toDate.isBefore(fromDate)) {
          newDetails.samplingToDateErrMsg =
            "Sampling To Date must be after Sampling From Date";
          validDates = false;
        } else {
          newDetails.samplingToDateErrMsg = undefined;
        }

        if (fromDate.isAfter(toDate)) {
          newDetails.samplingFromDateErrMsg =
            "Sampling From Date must be before Sampling To Date";
          validDates = false;
        } else {
          newDetails.samplingFromDateErrMsg = undefined;
        }
      }

      setValidDates(validDates);
      setRedMessage("");
      if (TERSampleDetails?.purposeOfTestErrMsg) {
        TERSampleDetails.purposeOfTestErrMsg = "";
      }
      return newDetails;
    });
  };

  const [samplesAndTests, setSamplesAndTests] = useState<ITERSamplesAndTests[]>(
    [...[samplesAndTestSchema]]
  );

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getCountries();

        setCountries(response.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const handleAddTests = () => {
    const testsToAdd = testOptions.filter(
      (test) =>
        test?.labCodeMasterID &&
        selectedTestIds.includes(test.labCodeMasterID as any)
    );

    setTestOptions((prevOptions) =>
      prevOptions.filter(
        (test) => !selectedTestIds.includes(test.labCodeMasterID as any)
      )
    );

    setSelectedTestIds([]);

    setSamplesAndTests((prevSamples: any) => {
      return prevSamples.map((prevSample: any, index: number) => {
        if (index === searchInd) {
          const currentTestDetails = prevSample.labTERTestDetails || [];

          const addedTests = currentTestDetails.map((detail: any) =>
            strippedHtmlTags(detail.testDescription)
          );

          testsToAdd.forEach((test) => {
            const strippedTestDescription = strippedHtmlTags(test.description);
            if (!addedTests.includes(strippedTestDescription)) {
              currentTestDetails.push({
                testDescription: test.description.trim(),
                laboratory: selectedTestLaboratory,
                nooftestsrequired: 1,
                noOfSamples: 1,
                testMethodSOPDescription: test.testMethodSOPDescription,
              });
            }
          });

          return {
            ...prevSample,
            labTERTestDetails: currentTestDetails,
          };
        } else {
          return prevSample;
        }
      });
    });
  };

  const handleDeleteTestResult = (
    sampleIndex: number,
    testLabTestID: string,
    resultIndex: number
  ) => {
    setSamplesAndTests((prevSamples) => {
      const updatedSamples = prevSamples.map((item) => {
        const updatedLabTERTestDetails = item.labTERTestDetails.map((test) => {
          if (test.labTestID === testLabTestID) {
            const updatedLabTERTestResult = test.labTERTestResult
              ? test.labTERTestResult.filter((_, k) => k !== resultIndex)
              : [];

            if (updatedLabTERTestResult.length === 0) {
              updatedLabTERTestResult.push(defaultTestResult);
            }

            return {
              ...test,
              labTERTestResult: updatedLabTERTestResult,
            };
          } else {
            return test;
          }
        });

        return {
          ...item,
          labTERTestDetails: updatedLabTERTestDetails,
        };
      });

      return updatedSamples;
    });
  };

  const handleRemoveTest = (
    labDetails: any,
    description: string,
    ind: number
  ) => {
    let removeTheLabID = labDetails.filter(
      (x: ILabTestDetails) => x.testDescription != description
    );
    const newArray = samplesAndTests.map((item: ITERSamplesAndTests, i) => {
      if (ind === i) {
        return { ...item, "labTERTestDetails": removeTheLabID };
      } else {
        return item;
      }
    });
    setSamplesAndTests(newArray);
  };

  const handleAddTestResult = (sampleIndex: number, testLabTestID: string) => {
    const newResult = { ...defaultTestResult };

    setSamplesAndTests((prevSamplesAndTests) => {
      const updatedSamplesAndTests = prevSamplesAndTests.map((sample) => {
        const updatedLabTERTestDetails = sample.labTERTestDetails.map(
          (test) => {
            if (test.labTestID === testLabTestID) {
              const updatedLabTERTestResult = [
                ...(test.labTERTestResult || []),
                newResult,
              ];

              return {
                ...test,
                labTERTestResult: updatedLabTERTestResult,
              };
            }
            return test;
          }
        );

        if (
          sample.labTERTestDetails.some(
            (test) => test.labTestID === testLabTestID
          )
        ) {
        }

        return {
          ...sample,
          labTERTestDetails: updatedLabTERTestDetails,
        };
      });

      return updatedSamplesAndTests;
    });
  };
  const handleSamplesCountChange = (
    sampleIndex: number,
    testIndex: number,
    count: number
  ) => {
    const validatedCount = count < 1 ? 1 : count;

    setSamplesAndTests((prevSamples) => {
      return prevSamples.map((sample, sIndex) => {
        if (sIndex === sampleIndex) {
          const updatedLabTERTestDetails = sample.labTERTestDetails.map(
            (test, tIndex) => {
              if (tIndex === testIndex) {
                return {
                  ...test,
                  noOfSamples: validatedCount,
                };
              }
              return test;
            }
          );
          return {
            ...sample,
            labTERTestDetails: updatedLabTERTestDetails,
          };
        }
        return sample;
      });
    });
  };

  const handleDownload = (fileName: string, reportData: string, index: number, totalReports: number,  applicationNum: string) => {
      try {
        const decodedData = atob(reportData);
        const byteCharacters = Array.from(decodedData).map((char) =>
          char.charCodeAt(0)
        );
        const byteArray = new Uint8Array(byteCharacters);
  
        const blob = new Blob([byteArray], { type: "application/pdf" });
  
        FileSaver.saveAs(blob, fileName);
  
      // ✅ Redirect only if this is the last record
      if (index === totalReports - 1) {
        setTimeout(() => {
          window.location.href = `/eservices/rating-feedback?an=${encodeURIComponent(applicationNum)}`;
        }, 800);
      }
        //window.location.href = `/eservices/rating-feedback?an=${applicationNum}`;
      } catch (error) {
        console.error(error);
        message(NotifyType.Info, "Error downloading the file");
      }
    };

  const handleRepeatCountChange = (
    sampleIndex: number,
    testIndex: number,
    count: number
  ) => {
    const validatedCount = count < 1 ? 1 : count;

    setRepeatCounts((prev) => ({
      ...prev,
      [sampleIndex]: {
        ...(prev[sampleIndex] || {}),
        [testIndex]: validatedCount,
      },
    }));

    setSamplesAndTests((prevSamples) => {
      return prevSamples.map((sample, sIndex) => {
        if (sIndex === sampleIndex) {
          const updatedLabTERTestDetails = sample.labTERTestDetails.map(
            (test, tIndex) => {
              if (tIndex === testIndex) {
                return {
                  ...test,
                  nooftestsrequired: validatedCount,
                };
              }
              return test;
            }
          );
          return {
            ...sample,
            labTERTestDetails: updatedLabTERTestDetails,
          };
        }
        return sample;
      });
    });
  };
  useEffect(() => {
    btnLoaderHandler(btnNameForLoader ? true : false);
  }, [btnNameForLoader]);
  const toggleTestSelection = (
    labCodeMasterID: string | undefined,
    isChecked: boolean
  ) => {
    setTestOptions((prevOptions) =>
      prevOptions.map((test) =>
        test.labCodeMasterID === labCodeMasterID
          ? { ...test, isSelected: isChecked }
          : test
      )
    );

    setSelectedTestIds((prevSelected: any) => {
      if (isChecked) {
        return [...prevSelected, labCodeMasterID as string];
      } else {
        return prevSelected.filter((id: any) => id !== labCodeMasterID);
      }
    });
  };

  let bannerName = "Application for Laboratory Testing";
  if (isCancelRequest) {
    bannerName = "Submission of Cancellation Request";
  } else if (amendCase) {
    bannerName = "Submission of Amendment Request";
  } else if (IsAcknowledge) {
    bannerName = "Acknowledge Test";
  } else if (IsSubmitresultRequest) {
    bannerName = "Submission of Test Result";
  }
  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>

        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        {pageLoader || checkpageLoader ? (
          <Loader />
        ) : (
          <div className="row setup-content" id="step-1">
            <div className="col-md-12">
              <div className="tab-wizard-content">
                {acknowledgmentMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Application has been successfully Saved as Draft.
                        Service Acknowledgement Number: &nbsp;
                        {acknowledgmentMessage ? acknowledgmentMessage : ""}
                      </p>
                    </div>
                  </div>
                )}
                {cancelMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Cancellation Request Submitted Successfully.
                        Service Acknowledgement Number: &nbsp;
                        {cancelMessage ? cancelMessage : ""}
                      </p>
                    </div>
                  </div>
                )}
                {applicationNum && !cancelMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h2>
                        <center>Application Number: {applicationNum}</center>
                      </h2>
                    </div>
                  </div>
                )}

                {RedMessage && (
                  <div className="info-content">
                    <div className="att">
                      <br />
                      <div className="text-danger">
                        <center>{RedMessage}</center>
                      </div>
                    </div>
                  </div>
                )}
                {!IsSubmitresultRequest && !IsAcknowledge ? (
                  <PersonalInformation
                    profileInfo={personalInfo}
                    onModeOfPaymentChange={setModeOfPayment}
                  />
                ) : null}
                {IsAcknowledgeRequest ? (
                  <div className="personal-info">
                    <div className="clonable-block" data-toggle="cloner">
                      <div className="clonable" data-clone-number="1">
                        <div className="info-heading">
                          <table className="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <th className="grid-header">Report Name</th>
                                <th className="grid-header">Report Type</th>
                                <th className="grid-header">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reports
                                .filter((report) => {
                                  const actionedStatus =
                                    localStorage.getItem("psh-app-status");
                                  if (report.reportData === null) return false;
                                  const meta: ITERRequest = TERMeta.TERMeta;
                                  if (report.reportType === 5) {
                                    return (
                                      actionedStatus !== "Pending Sample(s)" &&
                                      actionedStatus !== "Sample(s) Received"
                                    );
                                  }
                                  return report.reportType === 3;
                                })
                                .map((report, index) => (
                                  <tr key={report.reportName}>
                                    <td>
                                      <center>
                                        <h6>{report.reportName}</h6>
                                      </center>
                                    </td>
                                    <td>
                                      <h6>
                                        {renderReportType(report.reportType)}
                                      </h6>
                                    </td>
                                    <td>
                                      <button
                                        className="ACKFile"
                                       onClick={() =>
                                          handleDownload(
                                            report.reportName,
                                            report.reportData,
                                            index,
                                            reports.length,
                                            applicationNum 
                                          )
                                        }
                                      >
                                        Download
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="info-content">
                  <div className="attt">
                    <h2>
                      <center>
                        <h2>Purpose Code: TER</h2>
                      </center>
                    </h2>
                  </div>
                </div>

                <Tabs
                  className="samples-and-tests-cavs"
                  activeKey={activeTab.toString()}
                  onSelect={(k: string | null) => {
                    if (k) {
                      setActiveTab(parseInt(k));
                    }
                  }}
                  id="controlled-tab-example"
                >
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={1} title="Sample Details">
                      <div className="personal-info">
                        <div className="info-heading">
                          <h2 className="pb-0">
                            Sample Details <center></center>
                          </h2>
                        </div>
                        {pageLoader || checkpageLoader ? (
                          <Loader />
                        ) : (
                          <div className="info-content">
                            <div className="row-mt-2">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Purpose of Application
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <select
                                        className={`form-select ${
                                          TERSampleDetails?.purposeOfTestErrMsg
                                            ? "border-danger op05"
                                            : ""
                                        }`}
                                        aria-label="Default select example"
                                        name="purposeOfTest"
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest ||
                                          modeOfPayment === "Biosurveillance"
                                        }
                                        value={
                                          modeOfPayment === "Biosurveillance"
                                            ? 1
                                            : TERSampleDetails?.purposeOfTest
                                        }
                                      >
                                        <option selected>-- Select --</option>
                                        {purposeOfTestOptions &&
                                          purposeOfTestOptions
                                            .filter((x) =>
                                              modeOfPayment ===
                                              "Biosurveillance"
                                                ? x.id === 1
                                                : x.name !== "Biosurveillance"
                                            )
                                            .map((x) => (
                                              <option key={x.id} value={x.id}>
                                                {x.name}
                                              </option>
                                            ))}
                                      </select>
                                      {TERSampleDetails?.purposeOfTestErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Purpose of Application.
                                        </div>
                                      )}

                                      {TERSampleDetails?.purposeOfTest ===
                                        7 && (
                                        <div className="col-lg-12 mt-2">
                                          <input
                                            type="text"
                                            className={`form-control ${
                                              !TERSampleDetails?.otherPurposeOfTest
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            maxLength={100}
                                            placeholder={
                                              showPlaceholder
                                                ? "Enter Purpose of Application"
                                                : ""
                                            }
                                            name="otherPurposeOfTest"
                                            value={
                                              TERSampleDetails?.otherPurposeOfTest
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                          {TERSampleDetails?.otherPurposeOfTestErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              {
                                                TERSampleDetails.otherPurposeOfTestErrMsg
                                              }
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-3">
                                  <label htmlFor="crossReference">
                                    Cross Reference
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    id="crossReference"
                                    name="crossReference"
                                    value={TERSampleDetails?.crossReference}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    maxLength={100}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleTERSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>

                              {modeOfPayment === "Biosurveillance" && (
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="row">
                                      <div className="col-lg-6 mt-2">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Biosurveillance Program
                                          <span className="star-red">*</span>
                                        </label>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="col-lg-12 mt-2">
                                          <select
                                            className={`form-select ${
                                              TERSampleDetails?.bioSurveillanceProgramErrMsg
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            aria-label="Default select example"
                                            name="bioSurveillanceProgram"
                                            value={
                                              TERSampleDetails?.bioSurveillanceProgram
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                          >
                                            <option selected>
                                              -- Select --
                                            </option>
                                            {bioSurveillanceProgramsOptions &&
                                              bioSurveillanceProgramsOptions.map(
                                                (x) => {
                                                  return (
                                                    <option value={x.label}>
                                                      {x.label}
                                                    </option>
                                                  );
                                                }
                                              )}
                                          </select>
                                          {TERSampleDetails?.bioSurveillanceProgramErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              Please select Biosurveillance
                                              Program.
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="row-mt-2">
                                <div className="row">
                                <div className="col-lg-3">
                                  <label htmlFor="countryofBirth">
                                      Country of Origin
                                      <span className="star-red">*</span>
                                    </label>
                                  </div>
                                <div className="col-lg-3">
                                   <div className="rs-container">
                                    <Select
                                      classNamePrefix="rs"
                                      options={countryOptions}
                                      value={countryOptions.find(
                                          (option) => option.value === TERSampleDetails?.countryofBirth
                                      )}
                                        onChange={handleSelectedChange("countryofBirth")}
                                      isDisabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      placeholder="Select a country"
                                        isSearchable
                                        isClearable={false}

                                        /* --- FIXED DROPDOWN BEHAVIOR --- */
                                        
                                        maxMenuHeight={260}                                        
                                        menuPlacement="auto"                                                                            
                                        filterOption={(option, inputValue) =>
                                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                      />

                                    {TERSampleDetails?.countryofBirthErrMsg && (
                                      <div className="error-message">
                                          <FontAwesomeIcon className="me-1" icon={faCircleExclamation} />
                                        Please Fill Country of Origin.
                                      </div>
                                    )}
                                    </div>
                                  </div>
                                  <div className="col-lg-3">
                                    <label htmlFor="crossReference">
                                      Country of Destination
                                      {TERSampleDetails?.purposeOfTest ===
                                        4 && (
                                        <span className="star-red">*</span>
                                      )}
                                    </label>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="rs-container">
                                    <Select
                                      classNamePrefix="rs"
                                      options={countryOptions}
                                      value={countryOptions.find(
                                        (option) =>
                                          option.value ===
                                          TERSampleDetails?.exportercountryOfDestination
                                      )}
                                      onChange={handleSelectedChange(
                                        "exportercountryOfDestination"
                                      )}
                                      isDisabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      placeholder="Select a country"
                                      isSearchable={true}
                                      isClearable={false}    
                                       /* --- FIXED DROPDOWN BEHAVIOR --- */
                                     
                                      maxMenuHeight={260}
                                      menuPlacement="auto" 
                                      filterOption={(option, inputValue) => {
                                        return option.label.toLowerCase().includes(inputValue.toLowerCase());
                                      }}
                                    />
                                    {TERSampleDetails?.exportercountryOfDestinationErrMsg && (
                                      <div className="error-message">
                                        <FontAwesomeIcon
                                          className="me-1"
                                          icon={faCircleExclamation}
                                        />
                                        Please fill Country of Destination.
                                      </div>
                                    )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row-mt-2">
                                <div className="row mt-2">
                                  <div className="row-mt-2">
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Sampling From Date{" "}
                                          <span className="star-red">*</span>
                                        </label>
                                      </div>
                                      <div className="col-lg-3">
                                        <input
                                          type="datetime-local"
                                          className={`form-control ${
                                            TERSampleDetails?.samplingToDate &&
                                            moment(
                                              TERSampleDetails?.samplingToDate
                                            ).isBefore(
                                              moment(
                                                TERSampleDetails?.samplingFromDate
                                              )
                                            )
                                              ? "border-danger"
                                              : ""
                                          }`}
                                          name="samplingFromDate"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          value={
                                            TERSampleDetails?.samplingFromDate
                                              ? moment(
                                                  TERSampleDetails.samplingFromDate
                                                ).format("YYYY-MM-DDTHH:mm")
                                              : ""
                                          }
                                          onChange={(e) =>
                                            handleTERSampleDetails(
                                              e,
                                              "datetime-local"
                                            )
                                          }
                                          /*max={
                                            TERSampleDetails?.samplingToDate
                                              ? moment(
                                                  TERSampleDetails?.samplingToDate
                                                ).format("YYYY-MM-DDTHH:mm")
                                              : maxDateTime
                                          }*/
                                        />
                                        {TERSampleDetails?.samplingFromDateErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            {
                                              TERSampleDetails?.samplingFromDateErrMsg
                                            }
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor="courierTrackingNo"
                                        >
                                          Sampling To Date{" "}
                                          <span className="star-red">*</span>
                                        </label>
                                      </div>
                                      <div className="col-lg-3">
                                        <input
                                          type="datetime-local"
                                          className={`form-control ${
                                            TERSampleDetails?.samplingFromDate &&
                                            moment(
                                              TERSampleDetails?.samplingToDate
                                            ).isBefore(
                                              moment(
                                                TERSampleDetails?.samplingFromDate
                                              )
                                            )
                                              ? "border-danger"
                                              : ""
                                          }`}
                                          name="samplingToDate"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledge ||
                                            IsAcknowledgeRequest ||
                                            IsSubmitresultRequest
                                          }
                                          value={
                                            TERSampleDetails?.samplingToDate
                                              ? moment(
                                                  TERSampleDetails.samplingToDate
                                                ).format("YYYY-MM-DDTHH:mm")
                                              : ""
                                          }
                                          onChange={(e) =>
                                            handleTERSampleDetails(
                                              e,
                                              "datetime-local"
                                            )
                                          }
                                          min={
                                            TERSampleDetails?.samplingFromDate
                                              ? moment(
                                                  TERSampleDetails?.samplingFromDate
                                                ).format("YYYY-MM-DDTHH:mm")
                                              : ""
                                          }
                                        />
                                        {TERSampleDetails?.samplingToDateErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            {
                                              TERSampleDetails?.samplingToDateErrMsg
                                            }
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div className="col-lg-3 mt-2">
                                  <label htmlFor="sampledBy">
                                    Sampled By{" "}
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-3 mt-2">
                                  <input
                                    type="text"
                                    id="sampledBy"
                                    name="sampledBy"
                                    value={TERSampleDetails?.sampledBy}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    maxLength={100}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleTERSampleDetails(e, "string")
                                    }
                                  />

                                  {TERSampleDetails?.sampledByErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please Fill Sampled By.
                                    </div>
                                  )}
                                </div>
                                <div className="col-lg-3">
                                  <label htmlFor="crossReference">
                                    Date to be Exported
                                    {TERSampleDetails?.purposeOfTest ===
                                      4 && <span className="star-red">*</span>}
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="date"
                                    id="dateExportedDate"
                                    name="dateExportedDate"
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    value={
                                      TERSampleDetails?.dateExportedDate
                                        ? moment(
                                            TERSampleDetails?.dateExportedDate
                                          ).format("YYYY-MM-DD")
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleTERSampleDetails(e, "string")
                                    }
                                    className="form-control"
                                  />
                                  {TERSampleDetails?.dateExportedDateErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please fill Date to be Exported.
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor="referringVeterinarian"
                                  >
                                    Referring Veterinarian{" "}
                                    {(TERSampleDetails?.purposeOfTest === 4 ||
                                      TERSampleDetails?.purposeOfTest ===
                                        6) && (
                                      <span className="star-red">*</span>
                                    )}
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="referringVeterinarian"
                                    maxLength={100}
                                    value={
                                      TERSampleDetails?.referringVeterinarian
                                    }
                                    onChange={(e) =>
                                      handleTERSampleDetails(e, "string")
                                    }
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                  />
                                  {TERSampleDetails?.referringVeterinarianErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please fill Veterinarian.
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row mt-2"></div>

                              <div className="col-lg-3">
                                <label className="form-check-label">
                                  <a
                                    href="#"
                                    className="font-weight-500"
                                    onClick={handleToggleFarmLocationDetails}
                                  >
                                    Farm/Location Details{" "}
                                    {showFarmLocationDetails ? "[-]" : "[+]"}
                                  </a>
                                </label>
                              </div>
                              {showFarmLocationDetails && (
                                <>
                                  {modeOfPayment === "Biosurveillance" && (
                                    <div className="row mb-3">
                                      <div className="col-lg-6">
                                        <div className="row">
                                          <div className="col-lg-6">
                                            <label
                                              className="form-check-label"
                                              htmlFor=""
                                            >
                                              Farm Code
                                            </label>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="col-lg-12 mt-2">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                                name="farmCode"
                                                value={
                                                  TERSampleDetails?.farmCode
                                                }
                                                disabled={
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                }
                                                onChange={(e) =>
                                                  handleTERSampleDetails(
                                                    e,
                                                    "string"
                                                  )
                                                }
                                              >
                                                <option selected>
                                                  -- Select --
                                                </option>
                                                {premisesCodeOptions.map(
                                                  (option) => (
                                                    <option
                                                      key={option.value}
                                                      value={option.value}
                                                    >
                                                      {option.label}
                                                    </option>
                                                  )
                                                )}
                                                <option
                                                  key="specialFarmCode"
                                                  value="specialfarmCode"
                                                >
                                                  Special Farm Code
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {TERSampleDetails?.farmCode ===
                                    "specialfarmCode" && (
                                    <div className="row mb-3">
                                      <div className="col-lg-6">
                                        <div className="row align-items-center">
                                          <div className="col-lg-6">
                                            <label
                                              className="form-check-label"
                                              htmlFor="specialFarmCode"
                                            >
                                              Special Farm Code
                                            </label>
                                          </div>
                                          <div className="col-lg-6">
                                            <input
                                              id="specialFarmCode"
                                              type="text"
                                              className="form-control"
                                              disabled={
                                                isCancelRequest ||
                                                IsAcknowledgeRequest ||
                                                IsAcknowledge ||
                                                IsSubmitresultRequest
                                              }
                                              placeholder={
                                                showPlaceholder
                                                  ? "Enter Special Farm Code"
                                                  : ""
                                              }
                                              name="specialFarmCode"
                                              value={
                                                TERSampleDetails?.specialFarmCode ||
                                                ""
                                              }
                                              maxLength={100}
                                              onChange={(e) =>
                                                handleTERSampleDetails(
                                                  e,
                                                  "string"
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="row align-items-center">
                                    <div className="col-lg-3">
                                      <label
                                        htmlFor="latitude"
                                        className="mb-0"
                                      >
                                        Latitude (Decimal Degrees)
                                      </label>
                                    </div>

                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        id="latitude"
                                        name="latitude"
                                        value={TERSampleDetails?.latitude}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                        placeholder={
                                          showPlaceholder ? "123.123456" : ""
                                        }
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "string")
                                        }
                                        maxLength={100}
                                      />
                                    </div>

                                    <div className="col-lg-3">
                                      <label
                                        htmlFor="longitude"
                                        className="mb-0"
                                      >
                                        Longitude (Decimal Degrees)
                                      </label>
                                    </div>

                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        id="longitude"
                                        name="longitude"
                                        value={TERSampleDetails?.longitude}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledge ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                        placeholder={
                                          showPlaceholder ? "123.123456" : ""
                                        }
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "string")
                                        }
                                        maxLength={100}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-2 align-items-center">
                                    <div className="col-lg-3">
                                      <label
                                        className="form-check-label"
                                        htmlFor="farmLocationName"
                                      >
                                        Location Name
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="farmLocationName"
                                        value={
                                          TERSampleDetails?.farmLocationName
                                        }
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "string")
                                        }
                                        maxLength={100}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-3">
                                      <label className="form-check-label">
                                        Farm/Location Address
                                      </label>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-checked">
                                        <label
                                          htmlFor="local"
                                          className="form-check-label"
                                        >
                                          <input
                                            type="radio"
                                            id="local"
                                            name="addressType"
                                            value="Local"
                                            className="form-check-input"
                                            checked={
                                              TERSampleDetails?.addressType ===
                                              "Local"
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(e, "radio")
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                          Local
                                        </label>
                                        <label
                                          htmlFor="foreign"
                                          className="form-check-label"
                                        >
                                          <input
                                            type="radio"
                                            id="foreign"
                                            name="addressType"
                                            className="form-check-input"
                                            value="Foreign"
                                            checked={
                                              TERSampleDetails?.addressType ===
                                              "Foreign"
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(e, "radio")
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                          Foreign
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="address">
                                    <div className="row mt-2">
                                      <div
                                        className={
                                          TERSampleDetails?.addressType ===
                                            "Local" &&
                                          modeOfPayment !== "Biosurveillance"
                                            ? "col-lg-9"
                                            : "col-lg-12"
                                        }
                                      >
                                        <div>
                                          <label className="form-check-label">
                                            Postal Code
                                          </label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            name="postalCode"
                                            value={TERSampleDetails?.postalCode}
                                            onChange={(e) => {
                                              const newValue = e.target.value;
                                              setpostalCode({
                                                ...postalCode,
                                                postalCode: newValue,
                                              });
                                              setTERSampleDetails({
                                                ...TERSampleDetails,
                                                postalCode: newValue,
                                              });
                                            }}
                                            maxLength={10}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                        </div>
                                      </div>

                                      {modeOfPayment !== "Biosurveillance" &&
                                        TERSampleDetails?.addressType ===
                                          "Local" && (
                                          <div className="col-lg-3">
                                            <div className="row">
                                              <div className="col-lg-12">
                                                <label htmlFor="button"></label>
                                                <br />
                                                <div>
                                                  <Button
                                                    className="btttn"
                                                    onClick={() => {
                                                      if (
                                                        TERSampleDetails.addressType
                                                      ) {
                                                        fetchData(
                                                          TERSampleDetails.addressType
                                                        );
                                                      } else {
                                                        message(
                                                          NotifyType.Error,
                                                          "Please select an address type (Local or Foreign) before retrieving."
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    Retrieve
                                                  </Button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      <div className="row mt-2">
                                        <div>
                                          <label htmlFor="streetRoadName">
                                            Street/Road Name
                                          </label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            name="roadName"
                                            value={TERSampleDetails?.roadName}
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                            maxLength={100}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledge ||
                                              IsAcknowledgeRequest ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="row mt-4">
                                        <div className="col-lg-4">
                                          <label htmlFor="blockHouseNo">
                                            Block/House No
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="houseNo"
                                            value={TERSampleDetails?.houseNo}
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                            maxLength={100}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                        </div>
                                        <div className="block">
                                          <label htmlFor="level">Level</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="level"
                                            value={TERSampleDetails?.level}
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                            maxLength={100}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                        </div>
                                        <div className="col-lg-4">
                                          <label htmlFor="unitNo">
                                            Unit No
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="unitNo"
                                            value={TERSampleDetails?.unitNo}
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                            maxLength={100}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-lg-4">
                                          <label htmlFor="buildingName">
                                            Building Name
                                          </label>
                                        </div>
                                        <div className="col-lg-12">
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="buildingName"
                                            value={
                                              TERSampleDetails?.buildingName
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                            maxLength={100}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                        </div>

                                        <div className="row mt-2">
                                          <div className="col-lg-6">
                                            <label htmlFor="CityName">
                                              City Name
                                            </label>
                                            <input
                                              type="text"
                                              id="cityName"
                                              name="cityName"
                                              value={TERSampleDetails?.cityName}
                                              className="form-control"
                                              onChange={(e) =>
                                                handleTERSampleDetails(
                                                  e,
                                                  "string"
                                                )
                                              }
                                              disabled={
                                                isCancelRequest ||
                                                IsAcknowledgeRequest ||
                                                IsAcknowledge ||
                                                IsSubmitresultRequest
                                              }
                                              maxLength={100}
                                            />
                                          </div>

                                          <div className="col-lg-6">
                                            <label htmlFor="State">
                                              State/Province
                                            </label>
                                            <input
                                              type="text"
                                              id="state"
                                              name="state"
                                              value={TERSampleDetails?.state}
                                              className="form-control"
                                              onChange={(e) =>
                                                handleTERSampleDetails(
                                                  e,
                                                  "string"
                                                )
                                              }
                                              disabled={
                                                isCancelRequest ||
                                                IsAcknowledgeRequest ||
                                                IsAcknowledge ||
                                                IsSubmitresultRequest
                                              }
                                              maxLength={100}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>{" "}
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor="country"
                                        >
                                          Country
                                        </label>
                                      </div>
                                      <div className="col-lg-12">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="country"
                                          value={TERSampleDetails?.country}
                                          onChange={(e) =>
                                            handleTERSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>

                            <div className="row mt-3">
                              <div className="col-lg-12">
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault1"
                                >
                                  <a
                                    href="#"
                                    className="font-weight-500"
                                    onClick={handleToggleForm}
                                  >
                                    History & Remarks:{" "}
                                    {showForm ? "[-]" : "[+]"}
                                  </a>
                                </label>
                              </div>
                            </div>
                            {showForm && (
                              <div className="row">
                                <div className="col-lg-3">
                                  <label htmlFor="historyAndRemarks"></label>
                                </div>
                                <div className="col-lg-9">
                                  <textarea
                                    id="history_Remarks"
                                    name="history_Remarks"
                                    value={TERSampleDetails?.history_Remarks}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleTERSampleDetails(e, "string")
                                    }
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    maxLength={500}
                                  />
                                  <p className="text-muted small mt-1">
                                    {TERSampleDetails?.history_Remarks
                                      ?.length || 0}{" "}
                                    / 500 characters
                                  </p>
                                </div>
                              </div>
                            )}

                            <div className="col-lg-3">
                              <label className="form-check-label">
                                <a
                                  href=""
                                  className="font-weight-500"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    toggleQuarantineInfo();
                                  }}
                                >
                                  Quarantine Information{" "}
                                  {showQuarantineInfo ? "[-]" : "[+]"}
                                </a>
                              </label>

                              {showQuarantineInfo && (
                                <div>
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-check">
                                        <input
                                          type="checkbox"
                                          name="inQuarantine"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          checked={
                                            TERSampleDetails?.inQuarantine
                                          }
                                          onChange={(e) =>
                                            handleTERSampleDetails(
                                              e,
                                              "checkbox"
                                            )
                                          }
                                          className="form-check-input mt10"
                                        />
                                        <label className="form-check-label">
                                          In Quarantine
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  {TERSampleDetails?.inQuarantine && (
                                    <div className="col-lg-12">
                                      <div className="col-lg-9">
                                        <label className="form-check-label">
                                          Import Licence No
                                        </label>
                                      </div>
                                      <input
                                        type="text"
                                        id="importLicenseNo"
                                        name="importLicenseNo"
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "string")
                                        }
                                        maxLength={100}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={
                                          TERSampleDetails?.importLicenseNo
                                        }
                                        className="form-control"
                                      />
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        <div className="personal-info">
                          <div className="info-heading">
                            <h2 className="pb-0">
                              Clinical History &amp; Disease Signs
                            </h2>
                          </div>
                          {pageLoader || checkpageLoader ? (
                            <Loader />
                          ) : (
                            <div className="info-content">
                              <div className="row">
                                <div className="col-lg-3">
                                  <label className="form-check-label">
                                    Health Status
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <div className="form-checked">
                                    <label
                                      htmlFor="Healthy"
                                      className="form-check-label"
                                    >
                                      <input
                                        type="radio"
                                        id="Healthy"
                                        name="healthy"
                                        value="1"
                                        className="form-check-input"
                                        checked={
                                          TERSampleDetails?.healthy === 1
                                        }
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "number")
                                        }
                                        required
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                      Healthy
                                    </label>
                                    <label
                                      htmlFor="Diseased"
                                      className="form-check-label"
                                    >
                                      <input
                                        type="radio"
                                        id="Diseased"
                                        name="healthy"
                                        value="2"
                                        className="form-check-input"
                                        checked={
                                          TERSampleDetails?.healthy === 2
                                        }
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                      Diseased
                                    </label>
                                  </div>
                                  {TERSampleDetails?.healthyErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please fill Clinical History
                                    </div>
                                  )}
                                </div>
                                {TERSampleDetails?.healthy === 2 && (
                                  <div className="row">
                                    <div className="col-lg-2">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Disease Started on
                                      </label>
                                    </div>
                                    <div className="col-lg-4">
                                      <div
                                        className="input-group date"
                                        id="datepicker"
                                      >
                                        <input
                                          type="date"
                                          className="form-control"
                                          id="date"
                                          placeholder={
                                            showPlaceholder ? "DD/MM/YYYY" : ""
                                          }
                                          name="diseaseStartedon"
                                          value={
                                            TERSampleDetails?.diseaseStartedon
                                              ? moment(
                                                  TERSampleDetails?.diseaseStartedon
                                                ).format("YYYY-MM-DD")
                                              : ""
                                          }
                                          onChange={(e) =>
                                            handleTERSampleDetails(e, "string")
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          max={maxdate}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6 align-disease">
                                      <b>OR</b>
                                      <input
                                        type="number"
                                        name="ago"
                                        maxLength={20}
                                        value={TERSampleDetails?.ago}
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control ms-2"
                                        placeholder=""
                                      />
                                      <select
                                        value={TERSampleDetails?.yearsmonth}
                                        name="yearsmonth"
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "string")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-select ms-2"
                                        aria-label="Default select example"
                                      >
                                        <option selected />

                                        <option value={1}>Days</option>
                                        <option value={2}>Weeks</option>
                                        <option value={3}>Months</option>
                                        <option value={4}>Years</option>
                                      </select>
                                      <p className="ms-2">ago</p>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="row">
                                <div className="col-lg-2">
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    <a
                                      href="#"
                                      onClick={handleDiseaseSignClick}
                                    >
                                      Disease Sign: [
                                      {showAdditionalContent ? "-" : "+"}]
                                    </a>
                                  </label>
                                </div>
                              </div>

                              <div className="row">
                                {showAdditionalContent && (
                                  <div className="col-lg-12">
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Disease Pattern
                                        </label>
                                      </div>
                                      <div className="col-lg-3">
                                        <select
                                          className="form-select"
                                          name="pattern"
                                          onChange={(e) =>
                                            handleTERSampleDetails(e, "string")
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          value={TERSampleDetails?.pattern}
                                          aria-label="Default select example"
                                        >
                                          <option selected />

                                          <option value={1}>
                                            Increasing Mortality
                                          </option>
                                          <option value={2}>
                                            {" "}
                                            Low Grade Mortality
                                          </option>
                                          <option value={3}>
                                            Only Clinical Signs, No Mortality
                                          </option>
                                          <option value={4}>
                                            Sudden Deaths
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="row mt-2">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Total No. on Premises
                                        </label>
                                      </div>
                                      <div className="col-lg-3">
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder=""
                                          name="totalNoonPremises"
                                          value={
                                            TERSampleDetails?.totalNoonPremises
                                          }
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                      </div>
                                      <div className="col-lg-1"></div>
                                      <div className="col-lg-1">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          No. Dead Daily
                                        </label>
                                      </div>
                                      <div className="col-lg-2">
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder=""
                                          name="noDeadDaily"
                                          value={TERSampleDetails?.noDeadDaily}
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-2">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          No. or % Diseased
                                        </label>
                                      </div>
                                      <div className="col-lg-4">
                                        <div className="d-flex">
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder=""
                                            name="noDiseased"
                                            value={TERSampleDetails?.noDiseased}
                                            onChange={(e) => {
                                              if (e.target.value.length <= 10) {
                                                handleTERSampleDetails(
                                                  e,
                                                  "number"
                                                );
                                              }
                                            }}
                                            maxLength={50}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                          <select
                                            className="form-select ms-2"
                                            aria-label="Default select example"
                                            name="noOrDiseasedOptions"
                                            value={
                                              TERSampleDetails?.noOrDiseasedOptions
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              )
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          >
                                            <option selected />
                                            <option value={1}>Nos.</option>
                                            <option value={2}>%</option>
                                          </select>
                                        </div>
                                        {TERSampleDetails?.noOrDiseasedOptionsErrMsg && (
                                          <div className="error-message d-flex justify-content-start mt-1">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please fill No. or % Diseased
                                            options.
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-lg-1">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Total No. Dead
                                        </label>
                                      </div>
                                      <div className="col-lg-2">
                                        <input
                                          type="number"
                                          name="totalNoDead"
                                          className="form-control"
                                          placeholder=""
                                          value={TERSampleDetails?.totalNoDead}
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-2">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Total No. of Units
                                        </label>
                                      </div>

                                      <div className="col-lg-4">
                                        <div className="d-flex">
                                          <input
                                            type="number"
                                            name="totalNoofunits"
                                            value={
                                              TERSampleDetails?.totalNoofunits
                                            }
                                            onChange={(e) => {
                                              if (e.target.value.length <= 10) {
                                                handleTERSampleDetails(
                                                  e,
                                                  "number"
                                                );
                                              }
                                            }}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            className="form-control"
                                            placeholder=""
                                          />

                                          <select
                                            className="form-select ms-2"
                                            name="noOfUnitsOptions"
                                            value={
                                              TERSampleDetails?.noOfUnitsOptions
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              )
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            aria-label="Default select example"
                                          >
                                            <option selected />
                                            <option value={1}>nets</option>
                                            <option value={2}>ponds</option>
                                            <option value={3}>tanks</option>
                                          </select>
                                        </div>

                                        {TERSampleDetails?.noOfUnitsOptionsErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please fill Total No. of Units
                                            options.
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-lg-1">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Unit Size
                                        </label>
                                      </div>

                                      <div className="col-lg-4">
                                        <div className="d-flex">
                                          <input
                                            type="number"
                                            name="unitSize"
                                            value={TERSampleDetails?.unitSize}
                                            onChange={(e) => {
                                              if (e.target.value.length <= 10) {
                                                handleTERSampleDetails(
                                                  e,
                                                  "number"
                                                );
                                              }
                                            }}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            className="form-control"
                                            placeholder=""
                                          />

                                          <select
                                            className="form-select ms-2"
                                            name="unitsizeoptions"
                                            aria-label="Default select example"
                                            value={
                                              TERSampleDetails?.unitsizeoptions
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              )
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          >
                                            <option selected />
                                            <option value={1}>cm</option>
                                            <option value={2}>feet</option>
                                            <option value={3}>m</option>
                                          </select>
                                        </div>

                                        {TERSampleDetails?.unitsizeoptionsErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please fill Unit Size options.
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    <div className="row mt-2">
                                      <div className="col-lg-3">
                                        <label className="form-check-label">
                                          Farm Area
                                        </label>
                                      </div>
                                      <div className="col-lg-4">
                                        <div className="d-flex">
                                          <input
                                            type="number"
                                            name="farmArea"
                                            className="form-control"
                                            value={TERSampleDetails?.farmArea}
                                            onChange={(e) => {
                                              if (e.target.value.length <= 10) {
                                                handleTERSampleDetails(
                                                  e,
                                                  "number"
                                                );
                                              }
                                            }}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                          <select
                                            className="form-select ms-2"
                                            name="farmAreaOptions"
                                            value={
                                              TERSampleDetails?.farmAreaOptions
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              )
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            aria-label="Default select example"
                                          >
                                            <option selected />
                                            <option value={1}>ha</option>
                                            <option value={2}>m2</option>
                                          </select>
                                        </div>
                                        {TERSampleDetails?.farmAreaOptionsErrMsg && (
                                          <div className="error-message">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please fill Farm Area options.
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-lg-1">
                                        <label className="form-check-label">
                                          No. Affected
                                        </label>
                                      </div>
                                      <div className="col-lg-2">
                                        <input
                                          type="number"
                                          maxLength={20}
                                          name="noAfffected"
                                          value={TERSampleDetails?.noAfffected}
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          placeholder=""
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-2">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Age Affected
                                        </label>
                                      </div>
                                      <div className="col-lg-4">
                                        <div className="d-flex">
                                          <input
                                            type="number"
                                            name="ageAffected"
                                            onChange={(e) => {
                                              if (e.target.value.length <= 10) {
                                                handleTERSampleDetails(
                                                  e,
                                                  "number"
                                                );
                                              }
                                            }}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            className="form-control"
                                            value={
                                              TERSampleDetails?.ageAffected
                                            }
                                          />
                                          <select
                                            className="form-select ms-2"
                                            aria-label="Default select example"
                                            name="ageAffectedOptions"
                                            value={
                                              TERSampleDetails?.ageAffectedOptions
                                            }
                                            onChange={(e) =>
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              )
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          >
                                            <option selected />
                                            <option value={1}>days</option>
                                            <option value={2}>weeks</option>
                                            <option value={3}>months</option>
                                            <option value={4}>years</option>
                                          </select>
                                        </div>
                                        {TERSampleDetails?.ageAffectedOptionsErrMsg && (
                                          <div className="error-message d-flex justify-content-start mt-1">
                                            <FontAwesomeIcon
                                              className="me-1"
                                              icon={faCircleExclamation}
                                            />
                                            Please fill Age Affected options.
                                          </div>
                                        )}
                                      </div>

                                      <div className="col-lg-1">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Size Affected
                                        </label>
                                      </div>
                                      <div className="col-lg-2">
                                        <input
                                          type="number"
                                          name="sizeAffected"
                                          value={TERSampleDetails?.sizeAffected}
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleTERSampleDetails(
                                                e,
                                                "number"
                                              );
                                            }
                                          }}
                                          maxLength={50}
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          className="form-control"
                                          placeholder=""
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-2">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Other Species/Breed Affected
                                        </label>
                                      </div>
                                      <div className="col-lg-3">
                                        <input
                                          type="text"
                                          name="otherSpeciesAffected"
                                          onChange={(e) =>
                                            handleTERSampleDetails(e, "string")
                                          }
                                          maxLength={100}
                                          className="form-control"
                                          value={
                                            TERSampleDetails?.otherSpeciesAffected
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-2">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Clinical Signs &amp; Remarks
                                        </label>
                                      </div>
                                      <div className="col-lg-11">
                                        <textarea
                                          className="form-control"
                                          id="floatingTextarea"
                                          name="clinicalSigns"
                                          onChange={(e) =>
                                            handleTERSampleDetails(e, "string")
                                          }
                                          maxLength={500}
                                          value={
                                            TERSampleDetails?.clinicalSigns
                                          }
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                        />
                                        <p className="text-muted small mt-1">
                                          {TERSampleDetails?.clinicalSigns
                                            ?.length || 0}{" "}
                                          / 500 characters
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="row">
                                <div className="col-lg-12">
                                  <label
                                    className="form-check-label"
                                    htmlFor="clinicalManagement"
                                  >
                                    <a
                                      href=""
                                      className="font-weight-500"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        toggleClinicalManagement();
                                      }}
                                    >
                                      Clinical Management (Signs, Treatment &
                                      Remarks):{" "}
                                      {isClinicalManagementExpanded
                                        ? "[-]"
                                        : "[+]"}
                                    </a>
                                  </label>
                                </div>
                                {isClinicalManagementExpanded && (
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <textarea
                                        id="clinicalManagement"
                                        name="clinicalManagement"
                                        value={
                                          TERSampleDetails?.clinicalManagement
                                        }
                                        maxLength={500}
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "string")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        className="form-control"
                                      />

                                      <p className="text-muted small mt-1">
                                        {TERSampleDetails?.clinicalManagement
                                          ?.length || 0}{" "}
                                        / 500 characters
                                      </p>
                                    </div>
                                  </div>
                                )}
                                <div className="row">
                                  <div className="col-lg-12">
                                    <label
                                      className="form-check-label"
                                      htmlFor="vaccinationHistory"
                                    >
                                      <a
                                        href=""
                                        className="font-weight-500"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          toggleVaccinationHistory();
                                        }}
                                      >
                                        Vaccination History{" "}
                                        {isVaccinationHistoryExpanded
                                          ? "[-]"
                                          : "[+]"}
                                      </a>
                                    </label>
                                  </div>
                                  {isVaccinationHistoryExpanded && (
                                    <div className="col-lg-12">
                                      <div className="col-lg-3">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Clinical/Vaccination History
                                        </label>
                                      </div>
                                      <textarea
                                        id="vaccinationHistory"
                                        name="vaccinationHistory"
                                        value={
                                          TERSampleDetails?.vaccinationHistory
                                        }
                                        maxLength={500}
                                        className="form-control"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        required
                                        onChange={(e) =>
                                          handleTERSampleDetails(e, "string")
                                        }
                                      />
                                      <p className="text-muted small mt-1">
                                        {TERSampleDetails?.vaccinationHistory
                                          ?.length || 0}{" "}
                                        / 500 characters
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {isCancelRequest ? (
                        <div className="personal-info">
                          <div className="clonable-block" data-toggle="cloner">
                            <div className="clonable" data-clone-number="1">
                              <div className="info-heading">
                                <h2>
                                  Reason(s) for cancellation
                                  <span className="star-red">*</span>
                                </h2>
                              </div>
                              <div className="info-content">
                                <textarea
                                  className="form-control"
                                  placeholder=""
                                  name="cancel-request-comments"
                                  value={cancelComments}
                                  onChange={(e) =>
                                    setCancelComments(e.target.value)
                                  }
                                  maxLength={500}
                                ></textarea>
                                {cancelCommentsErrMsg && (
                                  <div className="error-message">
                                    <FontAwesomeIcon
                                      className="me-1"
                                      icon={faCircleExclamation}
                                    />
                                    Please fill Reason(s) for cancellation
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </Tab>
                  )}
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={2} title="Samples & Tests">
                      <div>
                        {rejectedTestsMessage && (
                          <div className="alert alert-warning">
                            {rejectedTestsMessage}
                          </div>
                        )}
                        {samplesAndTests &&
                          samplesAndTests.map(
                            (sample: ITERSamplesAndTests, index: number) => {
                              return (
                                <div className="personal-info" key={index}>
                                  <div
                                    className="clonable-block"
                                    data-toggle="cloner"
                                  >
                                    <div
                                      className="clonable"
                                      data-clone-number={index + 1}
                                    >
                                      <div className="info-heading">
                                        {amendCase !== "CASE4" &&
                                        !isCancelRequest &&
                                        !IsSubmitresultRequest &&
                                        !IsAcknowledge &&
                                        !IsAcknowledgeRequest ? (
                                          <ul className="card-icons float-end">
                                            <li>
                                              <button
                                                className="icon-button"
                                                title="New"
                                                onClick={handleAddSample}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faPlus}
                                                />
                                              </button>
                                            </li>
                                            <li className="copy-button-container">
                                              <button
                                                className="icon-button"
                                                title="Copy"
                                                onClick={() =>
                                                  handleCopyButtonClick(index)
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faCopy}
                                                />
                                              </button>
                                              <input
                                                type="number"
                                                className="copy-input"
                                                min="1"
                                                value={copyCount}
                                                onChange={handleCopyInputChange}
                                              />
                                            </li>

                                            <li>
                                              <button
                                                className="icon-button"
                                                onClick={() =>
                                                  handleDeleteSample(sample?.id)
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTrashCan}
                                                />
                                              </button>
                                            </li>
                                          </ul>
                                        ) : (
                                          ""
                                        )}
                                        <h2 className="pb-0">
                                          Serial number {index + 1}
                                        </h2>
                                      </div>
                                      <div className="info-content">
                                        <div className="table-responsive mt-2 mb-2">
                                          <table className="table table-striped product_table start_table">
                                            <thead>
                                              <tr>
                                                <th className="w-34">
                                                  Animal Type
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </th>
                                                <th className="w-34">
                                                  Species/Breed
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </th>
                                                <th className="w-34">
                                                  Sample Description
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <div className="rs-container rs-in-table">
                                                  <Select
                                                    id={`species-${index}`}
                                                    className={
                                                      sample?.speciesErrMsg
                                                        ? "border-danger"
                                                        : ""
                                                    }
                                                    classNamePrefix="rs"
                                                    options={
                                                      speciesSelectOptions
                                                    }
                                                    value={
                                                      speciesSelectOptions?.find(
                                                        (option: any) =>
                                                          option.value ===
                                                          sample.species
                                                      ) || null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) => {
                                                      handleSelectChange(
                                                        index,
                                                        "species"
                                                      )(selectedOption);
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={false}
                                                    maxMenuHeight={260}
                                                    menuPlacement="auto"
                                                    placeholder={
                                                      showPlaceholder
                                                        ? "Select Animal Type"
                                                        : ""
                                                    }
                                                    isDisabled={
                                                      isCancelRequest ||
                                                      IsAcknowledge ||
                                                      IsSubmitresultRequest
                                                    }
                                                    filterOption={(option, inputValue) =>
                                                      option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                                  />
                                                  {sample.species?.toUpperCase() ===
                                                    "Others".toUpperCase() && (
                                                    <input
                                                      type="text"
                                                      name="otherSpecies"
                                                      className="form-control mt-2"
                                                      value={
                                                        sample?.otherSpecies
                                                      }
                                                      maxLength={100}
                                                      onChange={handleSamplesAndTestsChange(
                                                        index,
                                                        "string"
                                                      )}
                                                      disabled={
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      placeholder={
                                                        showPlaceholder
                                                          ? "Enter Animal Type"
                                                          : ""
                                                      }
                                                    />
                                                  )}
                                                  {sample?.speciesErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      Please fill Animal Type.
                                                    </div>
                                                  )}
                                                  </div>
                                                </td>
                                                <td>
                                                  <Select
                                                    id={`breed-${index}`}
                                                    classNamePrefix="rs"
                                                    className={sample?.breedErrMsg
                                                      ? " border-danger"
                                                      : ""}                                                   
                                                      options={
                                                        sample.breedOptions || []
                                                      }
                                                      value={
                                                        sample.breedOptions?.find(
                                                          (option: any) =>
                                                            option.value ===
                                                            sample.breed
                                                        ) || null
                                                      }
                                                      onChange={(
                                                        selectedOption
                                                      ) => {
                                                        handleSelectChange(
                                                          index,
                                                          "breed"
                                                        )(selectedOption);
                                                      }}
                                                      
                                                      isSearchable={true}
                                                      isClearable={false}
                                                      maxMenuHeight={260}
                                                      menuPlacement="auto"
                                                      placeholder={
                                                        showPlaceholder
                                                          ? "Enter Species/Breed"
                                                          : ""
                                                      }
                                                      isDisabled={
                                                        isCancelRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      filterOption={(option, inputValue) =>
                                                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                      }
                                                  />

                                                  {sample?.breed?.toUpperCase() ===
                                                    "Others".toUpperCase() && (
                                                    <input
                                                      type="text"
                                                      className="form-control mt-2"
                                                      name="otherBreed"
                                                      value={sample?.otherBreed}
                                                      maxLength={100}
                                                      placeholder={
                                                        showPlaceholder
                                                          ? "Enter Species/Breed"
                                                          : ""
                                                      }
                                                      onChange={handleSamplesAndTestsChange(
                                                        index,
                                                        "string"
                                                      )}
                                                      disabled={
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                    />
                                                  )}
                                                  {sample?.breedErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      Please fill Species/Breed.
                                                    </div>
                                                  )}
                                                </td>
                                                <td>
                                                  <Select
                                                    id={`specimen-${index}`}
                                                    classNamePrefix="rs"
                                                    className={sample?.specimenDescriptionErrMsg
                                                      ? " border-danger"
                                                      : ""}
                                                    options={
                                                      sample.specimenOptions ||
                                                      []
                                                    }
                                                    value={
                                                      sample.specimenOptions?.find(
                                                        (option: any) =>
                                                          option.value ===
                                                          sample.specimenDescription
                                                      ) || null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) => {
                                                      handleSelectChange(
                                                        index,
                                                        "specimenDescription"
                                                      )(selectedOption);
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={false}
                                                    maxMenuHeight={260}
                                                    menuPlacement="auto"
                                                    placeholder={
                                                      showPlaceholder
                                                        ? "Enter Specimen Desc"
                                                        : ""
                                                    }
                                                    isDisabled={
                                                      isCancelRequest ||
                                                      IsAcknowledge ||
                                                      IsSubmitresultRequest
                                                    }
                                                    filterOption={(option, inputValue) =>
                                                      option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                                  />

                                                  {sample.specimenDescription?.toUpperCase() ===
                                                    "Others".toUpperCase() && (
                                                    <input
                                                      type="text"
                                                      className="form-control mt-2"
                                                      name="otherSpecimenDescription"
                                                      value={
                                                        sample?.otherSpecimenDescription
                                                      }
                                                      maxLength={100}
                                                      disabled={
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      onChange={handleSamplesAndTestsChange(
                                                        index,
                                                        "string"
                                                      )}
                                                      placeholder={
                                                        showPlaceholder
                                                          ? "Enter Specimen Desc"
                                                          : ""
                                                      }
                                                    />
                                                  )}
                                                  {sample?.specimenDescriptionErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      Please fill Specimen
                                                      Description.
                                                    </div>
                                                  )}
                                                </td>
                                              </tr>

                                              <tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Sample Marking{" "}
                                                        <span className="star-red">
                                                          *
                                                        </span>
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          name="sampleMarking"
                                                          value={
                                                            sample?.sampleMarking
                                                          }
                                                          maxLength={100}
                                                          className={`form-control ${
                                                            !sample?.sampleMarking
                                                              ? "border-danger op05"
                                                              : ""
                                                          }`}
                                                          onChange={handleSamplesAndTestsChange(
                                                            index,
                                                            "string"
                                                          )}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                        />
                                                      </div>
                                                      {sample?.sampleMarkingErrMsg && (
                                                        <div className="error-message">
                                                          <FontAwesomeIcon
                                                            className="me-1"
                                                            icon={
                                                              faCircleExclamation
                                                            }
                                                          />
                                                          {
                                                            sample.sampleMarkingErrMsg
                                                          }
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Number of Samples
                                                        <span className="star-red">
                                                          *
                                                        </span>
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="number"
                                                          min="1"
                                                          name="noOfSamples"
                                                          className="form-control"
                                                          value={
                                                            sample?.noOfSamples ??
                                                            1
                                                          }
                                                          disabled={
                                                            amendCase ==
                                                              "CASE4" ||
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                          onChange={handleSamplesAndTestsChange(
                                                            index,
                                                            "number"
                                                          )}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Test Information
                                                        <span className="star-red">
                                                          *
                                                        </span>
                                                      </label>
                                                      <div className="input-group date">
                                                        <button
                                                          className="btn btn-outline-success w-100 "
                                                          type="button"
                                                          onClick={() =>
                                                            handleShowSearchTestsModal(
                                                              index
                                                            )
                                                          }
                                                          disabled={
                                                            isCancelRequest ||
                                                            amendCase ==
                                                              "CASE4" ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                        >
                                                          Search Test
                                                        </button>
                                                        {sample?.labTERTestDetailsErrMsg && (
                                                          <div className="error-message">
                                                            <FontAwesomeIcon
                                                              className="me-1"
                                                              icon={
                                                                faCircleExclamation
                                                              }
                                                            />
                                                            Please add Test
                                                            Information.
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>

                                              {sample.labTERTestDetails &&
                                                sample.labTERTestDetails
                                                  .filter(
                                                    (test) =>
                                                      test.testDescription !==
                                                      ""
                                                  )
                                                  .map((test, testIndex) => (
                                                    <tr
                                                      key={`test-row-${index}-${testIndex}`}
                                                    >
                                                      <td
                                                        className="br-1"
                                                        colSpan={2}
                                                      >
                                                        <div className="mb-3">
                                                          <div className="mb-2">
                                                            <div className="test-detail">
                                                              <div
                                                                id={`testDescription-${index}-${test.labTestID}`}
                                                                className="test-description"
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    test.testDescription,
                                                                }}
                                                              />
                                                              {!(
                                                                amendCase ===
                                                                  "CASE4" ||
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              ) && (
                                                                <div
                                                                  className="test-remove-icon"
                                                                  onClick={() =>
                                                                    handleRemoveTest(
                                                                      sample.labTERTestDetails,
                                                                      test.testDescription,
                                                                      index
                                                                    )
                                                                  }
                                                                >
                                                                  <i className="bi bi-dash-circle"></i>
                                                                </div>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>

                                                      <td className="fnt-wg tr-ignore">
                                                        <div className="mb-3">
                                                          <div className="mb-2">
                                                            <label
                                                              htmlFor={`repeatCount-${index}-${testIndex}`}
                                                              className="col-form-label float-start"
                                                            >
                                                              Number of Tests
                                                              <span className="star-red">
                                                                *
                                                              </span>
                                                            </label>
                                                            <div className="input-group date">
                                                              <input
                                                                type="number"
                                                                id={`repeatCount-${index}-${testIndex}`}
                                                                min="1"
                                                                className="form-control"
                                                                value={
                                                                  repeatCounts[
                                                                    index
                                                                  ]?.[
                                                                    testIndex
                                                                  ] ??
                                                                  test.nooftestsrequired
                                                                }
                                                                disabled={
                                                                  amendCase ==
                                                                    "CASE4" ||
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                                onChange={(e) =>
                                                                  handleRepeatCountChange(
                                                                    index,
                                                                    testIndex,
                                                                    Math.min(
                                                                      Number(
                                                                        e.target
                                                                          .value
                                                                      ),
                                                                      1000
                                                                    )
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  ))}

                                              {sample.labTERTestDetails && (
                                                <>
                                                  {sample.labTERTestDetails.some(
                                                    (test) =>
                                                      test.testMethodSOPDescription
                                                        ?.trim()
                                                        .toLowerCase() ===
                                                      "post-mortem"
                                                  ) && (
                                                    <tr>
                                                      <td colSpan={3}>
                                                        <div className="col-lg-12">
                                                          <label
                                                            className="form-check-label"
                                                            htmlFor="flexRadioDefault1"
                                                          >
                                                            <a
                                                              href=""
                                                              className="font-weight-500"
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                                setShowPostMortem(
                                                                  !showPostMortem
                                                                );
                                                              }}
                                                            >
                                                              For Post Mortem:{" "}
                                                              {showPostMortem
                                                                ? "[-]"
                                                                : "[+]"}
                                                            </a>
                                                          </label>

                                                          {showPostMortem && (
                                                            <>
                                                              <div className="row">
                                                                <div className="col-lg-4">
                                                                  <label
                                                                    htmlFor="postMortemConsentForms"
                                                                    className="form-check-label"
                                                                    onMouseEnter={
                                                                      handleMouseEnter
                                                                    }
                                                                    onMouseLeave={
                                                                      handleMouseLeave
                                                                    }
                                                                    title="Documents allowed: pdf, docx, doc, jpg, jpeg, png, xlsx, xls."
                                                                  >
                                                                    Post-Mortem
                                                                    Consent Form
                                                                    <span className="star-red">
                                                                      *
                                                                    </span>
                                                                    <span
                                                                      className="csp-ml-5"
                                                                    >
                                                                      <FontAwesomeIcon
                                                                        icon={
                                                                          faInfoCircle
                                                                        }
                                                                      />
                                                                    </span>
                                                                  </label>
                                                                  <input
                                                                    type="file"
                                                                    className="form-control"
                                                                    id="postMortemConsentForms"
                                                                    multiple
                                                                    onChange={(
                                                                      event
                                                                    ) =>
                                                                      handlepostmartemFileChange(
                                                                        event,
                                                                        index
                                                                      )
                                                                    }
                                                                    disabled={
                                                                      isCancelRequest ||
                                                                      IsAcknowledgeRequest ||
                                                                      IsAcknowledge ||
                                                                      IsSubmitresultRequest
                                                                    }
                                                                  />

                                                                  {sample.postMortemConsentFormName &&
                                                                    sample
                                                                      .postMortemConsentFormName
                                                                      .length >
                                                                      0 && (
                                                                      <div className="file-view mt-2">
                                                                        {sample.postMortemConsentFormName
                                                                          .split(
                                                                            ", "
                                                                          )
                                                                          .map(
                                                                            (
                                                                              name,
                                                                              fileIndex
                                                                            ) => (
                                                                              <div
                                                                                key={
                                                                                  fileIndex
                                                                                }
                                                                                className="file-item d-flex align-items-center"
                                                                              >
                                                                                <div className="file-name">
                                                                                  {
                                                                                    name
                                                                                  }
                                                                                </div>
                                                                                {!(
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge ||
                                                                                  IsSubmitresultRequest
                                                                                ) && (
                                                                                  <div
                                                                                    className="test-remove-icon ml-2"
                                                                                    onClick={() =>
                                                                                      handledremoveFile(
                                                                                        name,
                                                                                        index,
                                                                                        fileIndex
                                                                                      )
                                                                                    }
                                                                                    title="Remove file"
                                                                                  >
                                                                                    <i className="bi bi-dash-circle"></i>
                                                                                  </div>
                                                                                )}
                                                                              </div>
                                                                            )
                                                                          )}
                                                                      </div>
                                                                    )}
                                                                  {sample?.postMortemConsentFormNameErrMsg && (
                                                                    <div className="error-message">
                                                                      <FontAwesomeIcon
                                                                        className="me-1"
                                                                        icon={
                                                                          faCircleExclamation
                                                                        }
                                                                      />
                                                                      Please
                                                                      submit
                                                                      consent
                                                                      form.
                                                                    </div>
                                                                  )}
                                                                </div>
                                                                <div className="col-lg-4">
                                                                  <label className="form-check-label">
                                                                    Save Remains
                                                                    for
                                                                    Burial/Cremation
                                                                    <span className="star-red">
                                                                      *
                                                                    </span>
                                                                  </label>
                                                                  <div className="form-checked">
                                                                    <select
                                                                      id="saveRemains"
                                                                      name="saveRemains"
                                                                      className="form-select"
                                                                      value={
                                                                        sample?.saveRemains ||
                                                                        ""
                                                                      }
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        handleSamplesAndTestsChange(
                                                                          index,
                                                                          "string"
                                                                        )(e);
                                                                      }}
                                                                      disabled={
                                                                        isCancelRequest ||
                                                                        IsAcknowledgeRequest ||
                                                                        IsAcknowledge ||
                                                                        IsSubmitresultRequest
                                                                      }
                                                                    >
                                                                      <option value="">
                                                                        Select
                                                                        an
                                                                        option
                                                                      </option>
                                                                      <option value="Yes">
                                                                        Yes
                                                                      </option>
                                                                      <option value="No">
                                                                        No
                                                                      </option>
                                                                    </select>
                                                                  </div>
                                                                  {sample?.saveRemainsErrMsg && (
                                                                    <div className="error-message">
                                                                      <FontAwesomeIcon
                                                                        className="me-1"
                                                                        icon={
                                                                          faCircleExclamation
                                                                        }
                                                                      />
                                                                      Please
                                                                      fill Save
                                                                      Remains.
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              </div>

                                                              <div className="row">
                                                                <div className="col-lg-4">
                                                                  <label className="form-check-label">
                                                                    Animal
                                                                    Status
                                                                  </label>
                                                                  <div className="form-checked">
                                                                    <label
                                                                      htmlFor="alive"
                                                                      className="form-check-label"
                                                                    >
                                                                      <input
                                                                        type="radio"
                                                                        id={`1-${index}`}
                                                                        name={`animalStatus-${index}`}
                                                                        value={
                                                                          1
                                                                        }
                                                                        className="form-check-input"
                                                                        checked={
                                                                          sample?.animalStatus ===
                                                                          1
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          handleSamplesAndTestsChange(
                                                                            index,
                                                                            "number"
                                                                          )(e);
                                                                        }}
                                                                        disabled={
                                                                          isCancelRequest ||
                                                                          IsAcknowledgeRequest ||
                                                                          IsAcknowledge ||
                                                                          IsSubmitresultRequest
                                                                        }
                                                                      />
                                                                      Alive
                                                                    </label>
                                                                    <label
                                                                      htmlFor="dead"
                                                                      className="form-check-label"
                                                                    >
                                                                      <input
                                                                        type="radio"
                                                                        id={`2-${index}`}
                                                                        name={`animalStatus-${index}`}
                                                                        value={
                                                                          2
                                                                        }
                                                                        className="form-check-input"
                                                                        checked={
                                                                          sample?.animalStatus ===
                                                                          2
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          handleSamplesAndTestsChange(
                                                                            index,
                                                                            "number"
                                                                          )(e);
                                                                        }}
                                                                        disabled={
                                                                          isCancelRequest ||
                                                                          IsAcknowledgeRequest ||
                                                                          IsAcknowledge ||
                                                                          IsSubmitresultRequest
                                                                        }
                                                                      />
                                                                      Dead
                                                                    </label>
                                                                  </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                  <label
                                                                    className="form-check-label"
                                                                    htmlFor="Remarks"
                                                                  >
                                                                    Remarks
                                                                  </label>
                                                                  <textarea
                                                                    className="form-control"
                                                                    name="remarks"
                                                                    value={
                                                                      sample?.remarks
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      handleSamplesAndTestsChange(
                                                                        index,
                                                                        "string"
                                                                      )(e);
                                                                    }}
                                                                    maxLength={
                                                                      500
                                                                    }
                                                                    disabled={
                                                                      isCancelRequest ||
                                                                      IsAcknowledgeRequest ||
                                                                      IsAcknowledge ||
                                                                      IsSubmitresultRequest
                                                                    }
                                                                  />
                                                                </div>
                                                              </div>
                                                              <div className="form-check col-lg-12">
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input mt10"
                                                                  id="euthanised"
                                                                  checked={
                                                                    sample?.euthanised
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleEuthanisedChange(
                                                                      e,
                                                                      index
                                                                    )
                                                                  }
                                                                  disabled={
                                                                    isCancelRequest ||
                                                                    IsAcknowledgeRequest ||
                                                                    IsAcknowledge ||
                                                                    IsSubmitresultRequest
                                                                  }
                                                                />
                                                                <label
                                                                  className="form-check-label"
                                                                  htmlFor="euthanised"
                                                                >
                                                                  Euthanised
                                                                </label>
                                                              </div>

                                                              {sample?.euthanised && (
                                                                <>
                                                                  <div className="col-lg-3">
                                                                    <label
                                                                      htmlFor="euthanisedDate"
                                                                      className="form-check-label"
                                                                    >
                                                                      Euthanised
                                                                      Date
                                                                    </label>
                                                                    <input
                                                                      type="date"
                                                                      id="euthanisedDate"
                                                                      name="euthanisedDate"
                                                                      value={
                                                                        sample?.euthanisedDate
                                                                          ? moment(
                                                                              sample?.euthanisedDate
                                                                            ).format(
                                                                              "YYYY-MM-DD"
                                                                            )
                                                                          : ""
                                                                      }
                                                                      disabled={
                                                                        isCancelRequest ||
                                                                        IsAcknowledgeRequest ||
                                                                        IsAcknowledge ||
                                                                        IsSubmitresultRequest
                                                                      }
                                                                      className="form-control"
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        handleSamplesAndTestsChange(
                                                                          index,
                                                                          "string"
                                                                        )(e);
                                                                      }}
                                                                      max={
                                                                        maxdate
                                                                      }
                                                                    />
                                                                  </div>

                                                                  <div className="col-lg-3">
                                                                    <label
                                                                      htmlFor="methodofEuthanised"
                                                                      className="col-form-label"
                                                                    >
                                                                      Method of
                                                                      Euthanasia
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      id="methodofEuthanised"
                                                                      name="methodofEuthanised"
                                                                      value={
                                                                        sample?.methodofEuthanised ||
                                                                        ""
                                                                      }
                                                                      maxLength={
                                                                        100
                                                                      }
                                                                      className="form-control"
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        handleSamplesAndTestsChange(
                                                                          index,
                                                                          "string"
                                                                        )(e);
                                                                      }}
                                                                      disabled={
                                                                        isCancelRequest ||
                                                                        IsAcknowledgeRequest ||
                                                                        IsAcknowledge ||
                                                                        IsSubmitresultRequest
                                                                      }
                                                                    />
                                                                  </div>
                                                                </>
                                                              )}
                                                            </>
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </>
                                              )}

                                              <div className="col-lg-12">
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="flexRadioDefault1"
                                                >
                                                  <a
                                                    href=""
                                                    className="font-weight-500"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      setShowGroupAnimals(
                                                        !showGroupAnimals
                                                      );
                                                    }}
                                                  >
                                                    For Group Animals:{" "}
                                                    {showGroupAnimals
                                                      ? "[-]"
                                                      : "[+]"}
                                                  </a>
                                                </label>
                                              </div>

                                              {showGroupAnimals && (
                                                <>
                                                  <tr>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            No. on Premises
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              value={
                                                                sample?.noOnPremises
                                                              }
                                                              name="noOnPremises"
                                                              onChange={(e) => {
                                                                if (
                                                                  e.target.value
                                                                    .length <=
                                                                  10
                                                                ) {
                                                                  handleSamplesAndTestsChange(
                                                                    index,
                                                                    "number"
                                                                  )(e);
                                                                }
                                                              }}
                                                              maxLength={20}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            No. in Group/Pen
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              value={
                                                                sample?.noInGroup
                                                              }
                                                              maxLength={50}
                                                              name="noInGroup"
                                                              onChange={(e) => {
                                                                if (
                                                                  e.target.value
                                                                    .length <=
                                                                  10
                                                                ) {
                                                                  handleSamplesAndTestsChange(
                                                                    index,
                                                                    "number"
                                                                  )(e);
                                                                }
                                                              }}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            No. Sick
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              value={
                                                                sample?.noSick
                                                              }
                                                              maxLength={50}
                                                              name="noSick"
                                                              onChange={(e) => {
                                                                if (
                                                                  e.target.value
                                                                    .length <=
                                                                  10
                                                                ) {
                                                                  handleSamplesAndTestsChange(
                                                                    index,
                                                                    "number"
                                                                  )(e);
                                                                }
                                                              }}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            No. at Risk
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              value={
                                                                sample?.noAtRisk
                                                              }
                                                              maxLength={50}
                                                              name="noAtRisk"
                                                              onChange={(e) => {
                                                                if (
                                                                  e.target.value
                                                                    .length <=
                                                                  10
                                                                ) {
                                                                  handleSamplesAndTestsChange(
                                                                    index,
                                                                    "number"
                                                                  )(e);
                                                                }
                                                              }}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledge ||
                                                                IsAcknowledgeRequest ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            Herd/Group ID
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              value={
                                                                sample?.groupID
                                                              }
                                                              maxLength={20}
                                                              name="groupID"
                                                              onChange={handleSamplesAndTestsChange(
                                                                index,
                                                                "string"
                                                              )}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            House/Pen No
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              value={
                                                                sample?.penNo
                                                              }
                                                              name="penNo"
                                                              onChange={handleSamplesAndTestsChange(
                                                                index,
                                                                "string"
                                                              )}
                                                              maxLength={20}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    {" "}
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            No. Dead
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              value={
                                                                sample?.noDead
                                                              }
                                                              name="noDead"
                                                              onChange={(e) => {
                                                                if (
                                                                  e.target.value
                                                                    .length <=
                                                                  10
                                                                ) {
                                                                  handleSamplesAndTestsChange(
                                                                    index,
                                                                    "number"
                                                                  )(e);
                                                                }
                                                              }}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </>
                                              )}
                                              <div className="col-lg-12">
                                                <label className="form-check-label">
                                                  <a
                                                    href="#"
                                                    className="font-weight-500"
                                                    onClick={
                                                      handleToggleFarmDetails
                                                    }
                                                  >
                                                    For Individual Animal{" "}
                                                    {showFarmDetails
                                                      ? "[-]"
                                                      : "[+]"}
                                                  </a>
                                                </label>
                                              </div>
                                              {showFarmDetails && (
                                                <>
                                                  <tr>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            Owner
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              value={
                                                                sample?.owner
                                                              }
                                                              maxLength={100}
                                                              name="owner"
                                                              onChange={handleSamplesAndTestsChange(
                                                                index,
                                                                "string"
                                                              )}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            Name of Animal
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              value={
                                                                sample?.nameofAnimal
                                                              }
                                                              maxLength={100}
                                                              name="nameofAnimal"
                                                              onChange={handleSamplesAndTestsChange(
                                                                index,
                                                                "string"
                                                              )}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            ID/Microchip No.
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              value={
                                                                sample?.microchipNo
                                                              }
                                                              maxLength={40}
                                                              name="microchipNo"
                                                              onChange={handleSamplesAndTestsChange(
                                                                index,
                                                                "string"
                                                              )}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3 ">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="staticEmail"
                                                            className="col-form-label"
                                                          >
                                                            Date of Birth
                                                          </label>
                                                          <div className="input-group date">
                                                            <input
                                                              type="date"
                                                              className="form-control"
                                                              value={
                                                                sample?.dateofBirth
                                                                  ? moment(
                                                                      sample?.dateofBirth
                                                                    ).format(
                                                                      "YYYY-MM-DD"
                                                                    )
                                                                  : ""
                                                              }
                                                              name="dateofBirth"
                                                              onChange={handleSamplesAndTestsChange(
                                                                index,
                                                                "string"
                                                              )}
                                                              max={maxdate}
                                                              disabled={
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="Sterilized"
                                                            className="col-form-label"
                                                          >
                                                            Sterilized
                                                          </label>

                                                          <select
                                                            className="form-select"
                                                            name="sterilized"
                                                            onChange={handleSamplesAndTestsChange(
                                                              index,
                                                              "number"
                                                            )}
                                                            disabled={
                                                              isCancelRequest ||
                                                              IsAcknowledgeRequest ||
                                                              IsAcknowledge ||
                                                              IsSubmitresultRequest
                                                            }
                                                            value={
                                                              sample?.sterilized
                                                            }
                                                            aria-label="Default select example"
                                                          >
                                                            <option selected>
                                                              {" "}
                                                              -- Select --
                                                            </option>

                                                            <option value={1}>
                                                              Yes
                                                            </option>
                                                            <option value={2}>
                                                              {" "}
                                                              No
                                                            </option>
                                                            <option value={3}>
                                                              Unknown
                                                            </option>
                                                          </select>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="countryOfResidence"
                                                            className="col-form-label"
                                                          >
                                                            Country of Residence
                                                          </label>

                                                          <Select
                                                            id={`country-${index}`}
                                                            classNamePrefix="rs"
                                                            options={
                                                              countryOptions
                                                            }
                                                            value={countryOptions.find(
                                                              (option) =>
                                                                option.value ===
                                                                sample.countryofResidence
                                                            )}
                                                            onChange={handleSelectChange(
                                                              index,
                                                              "countryofResidence"
                                                            )}
                                                            isDisabled={
                                                              isCancelRequest ||
                                                              IsAcknowledgeRequest ||
                                                              IsAcknowledge ||
                                                              IsSubmitresultRequest
                                                            }
                                                            isSearchable={true}
                                                            isClearable={false}
                                                            maxMenuHeight={260}
                                                            menuPlacement="auto"
                                                            filterOption={(option, inputValue) =>
                                                              option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>

                                                  <tr>
                                                    <td className="fnt-wg tr-ignore">
                                                      <div className="mb-3">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="gender"
                                                            className="col-form-label"
                                                          >
                                                            Sex
                                                          </label>
                                                          <div className="input-group">
                                                            <label
                                                              className="form-check-label me-2"
                                                              htmlFor="male"
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`male-${index}`}
                                                                name={`gender-${index}`}
                                                                value="Male"
                                                                disabled={
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                                checked={
                                                                  sample?.gender ===
                                                                  "Male"
                                                                }
                                                                onChange={handleSamplesAndTestsChange(
                                                                  index,
                                                                  "radio"
                                                                )}
                                                                className="form-check-input"
                                                              />
                                                              Male
                                                            </label>

                                                            <label
                                                              className="form-check-label me-2"
                                                              htmlFor="female"
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`female-${index}`}
                                                                name={`gender-${index}`}
                                                                value="Female"
                                                                disabled={
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                                checked={
                                                                  sample?.gender ===
                                                                  "Female"
                                                                }
                                                                onChange={handleSamplesAndTestsChange(
                                                                  index,
                                                                  "string"
                                                                )}
                                                                className="form-check-input"
                                                              />
                                                              Female
                                                            </label>

                                                            <label
                                                              className="form-check-label"
                                                              htmlFor="unknown"
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`unknown-${index}`}
                                                                name={`gender-${index}`}
                                                                value="unknown"
                                                                disabled={
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                                checked={
                                                                  sample?.gender ===
                                                                  "unknown"
                                                                }
                                                                onChange={handleSamplesAndTestsChange(
                                                                  index,
                                                                  "radio"
                                                                )}
                                                                className="form-check-input"
                                                              />
                                                              Unknown
                                                            </label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td
                                                      className="fnt-wg tr-ignore"
                                                      colSpan={2}
                                                    >
                                                      <div className="mb-3">
                                                        <div className="mb-2">
                                                          <label
                                                            htmlFor="age"
                                                            className="col-form-label"
                                                          >
                                                            Age
                                                          </label>
                                                          <div className="input-group">
                                                            <div className="row">
                                                              <div className="col-lg-4">
                                                                <label className="form-label">
                                                                  Years
                                                                </label>
                                                                <input
                                                                  type="number"
                                                                  className="form-control"
                                                                  name="years"
                                                                  value={
                                                                    sample?.years
                                                                  }
                                                                  disabled={
                                                                    isCancelRequest ||
                                                                    IsAcknowledgeRequest ||
                                                                    IsAcknowledge ||
                                                                    IsSubmitresultRequest
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      e.target
                                                                        .value
                                                                        .length <=
                                                                      3
                                                                    ) {
                                                                      handleSamplesAndTestsChange(
                                                                        index,
                                                                        "number"
                                                                      )(e);
                                                                    }
                                                                  }}
                                                                  placeholder={
                                                                    showPlaceholder
                                                                      ? "yrs"
                                                                      : ""
                                                                  }
                                                                />
                                                              </div>
                                                              <div className="col-lg-4">
                                                                <label className="form-label">
                                                                  Months
                                                                </label>
                                                                <input
                                                                  type="number"
                                                                  className="form-control"
                                                                  name="months"
                                                                  value={
                                                                    sample?.months
                                                                  }
                                                                  disabled={
                                                                    isCancelRequest ||
                                                                    IsAcknowledgeRequest ||
                                                                    IsAcknowledge ||
                                                                    IsSubmitresultRequest
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      e.target
                                                                        .value
                                                                        .length <=
                                                                      3
                                                                    ) {
                                                                      handleSamplesAndTestsChange(
                                                                        index,
                                                                        "number"
                                                                      )(e);
                                                                    }
                                                                  }}
                                                                  placeholder={
                                                                    showPlaceholder
                                                                      ? "months"
                                                                      : ""
                                                                  }
                                                                />
                                                              </div>
                                                              <div className="col-lg-4">
                                                                <label className="form-label">
                                                                  Weeks
                                                                </label>
                                                                <input
                                                                  type="number"
                                                                  className="form-control"
                                                                  name="weeks"
                                                                  value={
                                                                    sample?.weeks
                                                                  }
                                                                  disabled={
                                                                    isCancelRequest ||
                                                                    IsAcknowledgeRequest ||
                                                                    IsAcknowledge ||
                                                                    IsSubmitresultRequest
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      e.target
                                                                        .value
                                                                        .length <=
                                                                      3
                                                                    ) {
                                                                      handleSamplesAndTestsChange(
                                                                        index,
                                                                        "number"
                                                                      )(e);
                                                                    }
                                                                  }}
                                                                  placeholder={
                                                                    showPlaceholder
                                                                      ? "weeks"
                                                                      : ""
                                                                  }
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                        <hr></hr>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                      </div>
                    </Tab>
                  )}
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={3} title="My Preference">
                      <div className="personal-info">
                        <div className="clonable-block">
                          <div className="clonable">
                            <div className="info-content">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="SpecialInstructions"
                                      >
                                        For Bacterial Culture Only
                                      </label>
                                    </div>
                                    <div className="col-lg-7 d-flex align-items-center">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-2"
                                        name="antimicrobialSusceptibilityTestRequired"
                                        onChange={(e) =>
                                          handleMyPreference(e, "checkbox")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest ||
                                          IsAcknowledge ||
                                          amendCase === "CASE4"
                                        }
                                        checked={
                                          Preference?.antimicrobialSusceptibilityTestRequired
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="antimicrobialSusceptibilityTestRequired"
                                      >
                                        Antimicrobial Susceptibility Test
                                        Required
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="specialInstructions"
                                      >
                                        Special Instructions/ Additional
                                        Information
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <textarea
                                        className="form-control"
                                        name="specialInstructions"
                                        onChange={(e) =>
                                          handleMyPreference(e, "input")
                                        }
                                        maxLength={500}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={Preference?.specialInstructions}
                                      />

                                      <p className="text-muted small mt-1">
                                        {Preference?.specialInstructions
                                          ?.length || 0}{" "}
                                        / 500 characters
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="row mt-2 mt-lg-0">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="otherRemarks"
                                      >
                                        Other Remarks
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <textarea
                                        className="form-control"
                                        name="remarks"
                                        value={Preference?.remarks}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        maxLength={500}
                                        onChange={(e) =>
                                          handleMyPreference(e, "input")
                                        }
                                      />

                                      <p className="text-muted small mt-1">
                                        {Preference?.remarks?.length || 0} / 500
                                        characters
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6 mt-3">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        htmlFor="supportDocuments"
                                        className="form-check-label"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                        title="Documents allowed: pdf, docx, doc, jpg, jpeg, png, xlsx, xls."
                                      >
                                        Support Documents
                                        <span className="csp-ml-5">
                                          <FontAwesomeIcon
                                            icon={faInfoCircle}
                                          />
                                        </span>
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="SupportDocuments"
                                        multiple
                                        onChange={handledFileChange}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                      {Preference?.supportDocumentName && (
                                        <div className="file-view mt-2">
                                          {Preference.supportDocumentName
                                            .split(", ")
                                            .map((name, index) => (
                                              <div
                                                key={index}
                                                className="file-item d-flex align-items-center"
                                              >
                                                <div className="file-name">
                                                  {name}
                                                </div>
                                                {!(
                                                  amendCase === "CASE4" ||
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                ) && (
                                                  <div
                                                    className="test-remove-icon ml-2"
                                                    onClick={() =>
                                                      handleRemoveFile(name)
                                                    }
                                                    title="Remove file"
                                                  >
                                                    <i className="bi bi-dash-circle"></i>
                                                  </div>
                                                )}
                                              </div>
                                            ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6 mt-3">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="modeOfReceiving"
                                      >
                                        Mode of receiving report
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <select
                                        name="modeOfReceiving"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={Preference?.modeOfReceiving}
                                        onChange={(e) => {
                                          handleMyPreference(e, "number");

                                          const value = Number(e.target.value);

                                          if (value === 1 || value === 3) {
                                            setPreference((prevState) => ({
                                              ...prevState,
                                              hardcopy: "Yes",
                                            }));
                                          } else {
                                            setPreference((prevState) => ({
                                              ...prevState,
                                              hardcopy: "No",
                                            }));
                                          }
                                        }}
                                        className="form-select"
                                        aria-label="Mode of receiving report"
                                      >
                                        <option value="" selected>
                                          Select an option
                                        </option>
                                        <option value={2}>Email</option>
                                      </select>

                                      {Preference?.modeOfReceivingErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please select Mode of Report.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {Preference?.modeOfReceiving === 1 && (
                                  <div className="row mt-2">
                                    <div className="col-lg-6">
                                      <label className="form-check-label fw-bold mb-2">
                                        Please select the address for mailing:
                                      </label>
                                      <select
                                        name="mailingAddress"
                                        className="form-select mb-3"
                                        value={Preference?.mailingAddress}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        onChange={(e) =>
                                          handleMyPreference(e, "number")
                                        }
                                      >
                                        <option value="" selected>
                                          Please Select address
                                        </option>
                                        <option value={1}>
                                          Same as mailing address
                                        </option>
                                        <option value={2}>
                                          Same as billing address
                                        </option>
                                        <option value={3}>
                                          Others (please specify)
                                        </option>
                                      </select>
                                      {Preference?.mailingAddressErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please Select the address
                                        </div>
                                      )}

                                      {Preference?.mailingAddress === 3 && (
                                        <div className="col-lg-12">
                                          <textarea
                                            className="form-control mt-2"
                                            placeholder="Enter address"
                                            name="customAddress"
                                            value={Preference?.customAddress}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleMyPreference(e, "input")
                                            }
                                          />
                                        </div>
                                      )}
                                      {Preference?.customAddressErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please enter address
                                        </div>
                                      )}

                                      <div className="alert alert-warning mt-3">
                                        Please note that NParks is not liable
                                        for lost mail, and any additional copies
                                        of laboratory reports are subject to
                                        additional charges.
                                      </div>

                                      <div className="form-check mt-3">
                                        <input
                                          type="checkbox"
                                          className="form-check-input mt-2"
                                          id="acknowledgeCheckbox"
                                          name="acknowledge"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          checked={
                                            Preference?.acknowledge || false
                                          }
                                          onChange={(e) =>
                                            handleMyPreference(e, "checkbox")
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="acknowledgeCheckbox"
                                        >
                                          I acknowledge the above information
                                        </label>
                                      </div>

                                      {Preference?.acknowledgeErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          You must acknowledge before proceeding
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                  )}
                  {(IsSubmitresultRequest || IsAcknowledge) && (
                    <Tab eventKey={4} title="Results">
                      {samplesAndTests &&
                        samplesAndTests
                          .filter((sample) => {
                            return sample.labTERTestDetails.some(
                              (test: any) => {
                                const isValidTest =
                                  test.isThirdPartyLab === 1 &&
                                  test.rowId === testRowId &&
                                  test.thirdPartyNric === customerNRIC &&
                                  (test.testStatus === null ||
                                    test.testStatus !== 8);

                                return isValidTest;
                              }
                            );
                          })
                          .map(
                            (
                              sample: ITERSamplesAndTests,
                              sampleIndex: number
                            ) => {
                              return (
                                <div
                                  className="personal-info"
                                  key={sampleIndex}
                                >
                                  <div
                                    className="clonable-block"
                                    data-toggle="cloner"
                                  >
                                    <div
                                      className="clonable"
                                      data-clone-number={sampleIndex + 1}
                                    >
                                      <div className="info-heading">
                                        <h2 className="pb-0">
                                          Serial number {sampleIndex + 1}
                                        </h2>
                                      </div>

                                      <div className="info-content">
                                        <div className="table-responsive mt-2 mb-2">
                                          <table className="table table-striped product_table start_table">
                                            <thead> </thead>

                                            <tbody>
                                              <div>
                                                {sample.labTERTestDetails &&
                                                  sample.labTERTestDetails
                                                    .filter((test: any) => {
                                                      const isValidTest =
                                                        test.isThirdPartyLab ===
                                                          1 &&
                                                        test.thirdPartyNric ===
                                                          customerNRIC &&
                                                        test.rowId ===
                                                          testRowId &&
                                                        (test.testStatus ===
                                                          null ||
                                                          test.testStatus !==
                                                            8);

                                                      return isValidTest;
                                                    })
                                                    .map((test, testIndex) => (
                                                      <tr
                                                        key={`test-row-${sampleIndex}-${test.labTestID}`}
                                                      >
                                                        <td className="br-1">
                                                          <div className="mb-3">
                                                            <div className="mb-2">
                                                              <div className="heading-test">
                                                                <h2 className="pb-0">
                                                                  {
                                                                    <div
                                                                      id={`testDescription-${sampleIndex}-${test.labTestID}`}
                                                                      className="test-description"
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          test.testDescription,
                                                                      }}
                                                                    />
                                                                  }
                                                                </h2>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className="info-content">
                                                            <div className="table table-striped product_table start_table">
                                                              <div className="d-flex flex-row justify-content-between align-items-center">
                                                                <div className="d-flex flex-column">
                                                                  <div className="d-flex flex-row align-items-center mt-2 mt-lg-0">
                                                                    <div className="col-lg-5">
                                                                      <label
                                                                        className="form-check-label"
                                                                        htmlFor="sampleMarking"
                                                                      >
                                                                        Sample
                                                                        Marking
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-lg-7">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={
                                                                          sample?.sampleMarking
                                                                        }
                                                                        maxLength={
                                                                          100
                                                                        }
                                                                        name="sampleMarking"
                                                                        disabled
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div className="d-flex flex-column">
                                                                  <div className="d-flex flex-row align-items-center">
                                                                    <div className="col-lg-5">
                                                                      <label
                                                                        htmlFor="supportDocuments"
                                                                        className="form-check-label"
                                                                        onMouseEnter={
                                                                          handleMouseEnter
                                                                        }
                                                                        onMouseLeave={
                                                                          handleMouseLeave
                                                                        }
                                                                        title="Documents allowed:pdf,docx,doc,jpg,jpeg,png,xlsx,xls."
                                                                      >
                                                                        Result
                                                                        Documents
                                                                        <span
                                                                          className="csp-ml-5"
                                                                        >
                                                                          <FontAwesomeIcon
                                                                            icon={
                                                                              faInfoCircle
                                                                            }
                                                                          />
                                                                        </span>
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-lg-7">
                                                                      <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        id="ResultDocuments"
                                                                        disabled={
                                                                          amendCase ==
                                                                            "CASE4" ||
                                                                          isCancelRequest ||
                                                                          IsAcknowledgeRequest ||
                                                                          IsAcknowledge
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          handledFiledChange(
                                                                            sampleIndex,
                                                                            test.labTestID ??
                                                                              "",

                                                                            e
                                                                          )
                                                                        }
                                                                        multiple
                                                                      />

                                                                      {test?.ResultDocumentName ? (
                                                                        <div className="file-view">
                                                                          {
                                                                            test?.ResultDocumentName
                                                                          }
                                                                        </div>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>

                                                            <div className="row">
                                                              {(test.labTERTestResult &&
                                                              test
                                                                .labTERTestResult
                                                                .length > 0
                                                                ? test.labTERTestResult
                                                                : [
                                                                    defaultTestResult,
                                                                  ]
                                                              ).map(
                                                                (
                                                                  result,
                                                                  resultIndex
                                                                ) => (
                                                                  <div
                                                                    className="row mt-2"
                                                                    key={`result-${test.labTestID}-${resultIndex}`}
                                                                  >
                                                                    {IsSubmitresultRequest && (
                                                                      <>
                                                                        <div className="info-heading">
                                                                          <ul className="card-icons float-end">
                                                                            <li>
                                                                              <button
                                                                                className="icon-button"
                                                                                title="New"
                                                                                onClick={() =>
                                                                                  handleAddTestResult(
                                                                                    sampleIndex,
                                                                                    test.labTestID ??
                                                                                      ""
                                                                                  )
                                                                                }
                                                                              >
                                                                                <FontAwesomeIcon
                                                                                  icon={
                                                                                    faPlus
                                                                                  }
                                                                                />
                                                                              </button>
                                                                            </li>
                                                                            <li className="copy-button-container">
                                                                              <button
                                                                                className="icon-button"
                                                                                title="Copy"
                                                                                onClick={() =>
                                                                                  handledCopyButtonClick(
                                                                                    sampleIndex,
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )
                                                                                }
                                                                              >
                                                                                <FontAwesomeIcon
                                                                                  icon={
                                                                                    faCopy
                                                                                  }
                                                                                />
                                                                              </button>
                                                                            </li>

                                                                            {resultIndex !==
                                                                              0 && (
                                                                              <li>
                                                                                <button
                                                                                  className="icon-button"
                                                                                  onClick={() =>
                                                                                    handleDeleteTestResult(
                                                                                      sampleIndex,
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )
                                                                                  }
                                                                                  title="Delete"
                                                                                >
                                                                                  <FontAwesomeIcon
                                                                                    icon={
                                                                                      faTrashCan
                                                                                    }
                                                                                  />
                                                                                </button>
                                                                              </li>
                                                                            )}
                                                                          </ul>
                                                                          <h2 className="labresults-heading">
                                                                            {resultIndex ===
                                                                            0
                                                                              ? "Test Result"
                                                                              : `Additional Result ${resultIndex}`}
                                                                          </h2>
                                                                        </div>
                                                                      </>
                                                                    )}

                                                                    <>
                                                                      {test.isPostMartem ===
                                                                        0 && (
                                                                        <>
                                                                          <div className="row align-items-center">
                                                                            <div className="col-lg-6">
                                                                              <label
                                                                                className="form-check-label"
                                                                                htmlFor={`resultcode-${sampleIndex}-${test.labTestID}-${resultIndex}`}
                                                                              >
                                                                                Result
                                                                                Code
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <Select
                                                                                classNamePrefix="rs"
                                                                                options={
                                                                                  ResultCodeOptions
                                                                                }
                                                                                value={
                                                                                  ResultCodeOptions.find(
                                                                                    (
                                                                                      option
                                                                                    ) =>
                                                                                      option.value ===
                                                                                      result.resultcode
                                                                                  ) ||
                                                                                  null
                                                                                }
                                                                                isDisabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSelectChange(
                                                                                  sampleIndex,
                                                                                  "resultcode",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                              {result?.resultcodeErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Result
                                                                                  Code.
                                                                                </div>
                                                                              )}
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Units
                                                                              </label>
                                                                              <textarea
                                                                                id="units"
                                                                                className="form-control"
                                                                                name="units"
                                                                                value={
                                                                                  result?.units ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Testing
                                                                                Instructions
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <textarea
                                                                                id="testingInstruction"
                                                                                className="form-control"
                                                                                name="testingInstructions"
                                                                                value={
                                                                                  result?.testingInstructions ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />

                                                                              {result?.testingInstructionsErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Testing
                                                                                  Instructions.
                                                                                </div>
                                                                              )}
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Remarks
                                                                                for
                                                                                Third
                                                                                Party
                                                                                Laboratory
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <textarea
                                                                                id="remarksForThirdParty"
                                                                                className="form-control"
                                                                                name="remarksForThirdParty"
                                                                                value={
                                                                                  result?.remarksForThirdParty ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                              {result?.remarksForThirdPartyErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Remarks
                                                                                  for
                                                                                  Third
                                                                                  Party
                                                                                  Laboratory.
                                                                                </div>
                                                                              )}
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Symbol
                                                                                1
                                                                              </label>
                                                                              <select
                                                                                className="form-select"
                                                                                name="Symbol1"
                                                                                value={
                                                                                  result?.Symbol1 ||
                                                                                  ""
                                                                                }
                                                                                disabled={
                                                                                  amendCase ==
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "number",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              >
                                                                                <option value="">
                                                                                  Select
                                                                                </option>
                                                                                <option value="1">
                                                                                  &lt;
                                                                                </option>
                                                                                <option value="2">
                                                                                  &gt;
                                                                                </option>
                                                                                <option value="3">
                                                                                  +
                                                                                </option>
                                                                                <option value="4">
                                                                                  -
                                                                                </option>
                                                                              </select>
                                                                            </div>
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Readings
                                                                                1
                                                                              </label>
                                                                              <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name="Readings"
                                                                                step="0.01"
                                                                                disabled={
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                value={
                                                                                  result?.Readings ||
                                                                                  0
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "decimal",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Symbol
                                                                                2
                                                                              </label>
                                                                              <select
                                                                                className="form-select"
                                                                                name="Symbol2"
                                                                                value={
                                                                                  result?.Symbol2 ||
                                                                                  ""
                                                                                }
                                                                                disabled={
                                                                                  amendCase ==
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "number",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              >
                                                                                <option value="">
                                                                                  Select
                                                                                </option>
                                                                                <option value="1">
                                                                                  E
                                                                                </option>
                                                                                <option value="2">
                                                                                  /
                                                                                </option>
                                                                              </select>
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Reading
                                                                                2
                                                                              </label>
                                                                              <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name="Readings2"
                                                                                step="0.01"
                                                                                disabled={
                                                                                  amendCase ==
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                value={
                                                                                  result?.Readings2 ||
                                                                                  0
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "decimal",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Positive">
                                                                                Positive
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                id="Positive"
                                                                                className="form-control"
                                                                                name="Positive"
                                                                                value={
                                                                                  result?.Positive ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Negative">
                                                                                Negative
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="Negative"
                                                                                value={
                                                                                  result?.Negative ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Indefinite">
                                                                                Indefinite
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                id="Indefinite"
                                                                                className="form-control"
                                                                                name="Indefinite"
                                                                                value={
                                                                                  result?.Indefinite ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="ResultRemarks">
                                                                                Remarks
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="ResultRemarks"
                                                                                value={
                                                                                  result?.ResultRemarks ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      )}
                                                                    </>
                                                                    <>
                                                                      {test.isPostMartem ===
                                                                        1 && (
                                                                        <>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`resultcode-${sampleIndex}-${test.labTestID}-${resultIndex}`}
                                                                                  >
                                                                                    Result
                                                                                    Code
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <Select
                                                                                    classNamePrefix="rs"
                                                                                    options={
                                                                                      ResultCodeOptions
                                                                                    }
                                                                                    value={
                                                                                      ResultCodeOptions.find(
                                                                                        (
                                                                                          option
                                                                                        ) =>
                                                                                          option.value ===
                                                                                          result.resultcode
                                                                                      ) ||
                                                                                      null
                                                                                    }
                                                                                    isDisabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSelectChange(
                                                                                      sampleIndex,
                                                                                      "resultcode",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                  {result?.resultcodeErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Result
                                                                                      Code
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`units-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Units
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="units"
                                                                                    value={
                                                                                      result?.units ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`testingInstructions-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Testing
                                                                                    Instructions
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="testingInstructions"
                                                                                    value={
                                                                                      result?.testingInstructions ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                  {result?.testingInstructionsErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Testing
                                                                                      Instructions.
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Parasitology"
                                                                                  >
                                                                                    Remarks
                                                                                    for
                                                                                    Third
                                                                                    Party
                                                                                    Laboratory{" "}
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="remarksForThirdParty"
                                                                                    value={
                                                                                      result?.remarksForThirdParty ||
                                                                                      ""
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />

                                                                                  {result?.remarksForThirdPartyErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Remarks
                                                                                      for
                                                                                      Third
                                                                                      Party
                                                                                      Laboratory.
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`report-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Report
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="report"
                                                                                    value={
                                                                                      result?.report ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Parasitology"
                                                                                  >
                                                                                    Parasitology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Parasitology"
                                                                                    value={
                                                                                      result?.Parasitology ||
                                                                                      ""
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Microbiology"
                                                                                  >
                                                                                    Microbiology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Microbiology"
                                                                                    value={
                                                                                      result?.Microbiology ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Histopathology"
                                                                                  >
                                                                                    Histopathology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Histopathology"
                                                                                    value={
                                                                                      result?.Histopathology ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="ourreference"
                                                                                  >
                                                                                    Our
                                                                                    Reference
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="ourreference"
                                                                                    value={
                                                                                      result?.ourreference ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="finalDiagnosis"
                                                                                  >
                                                                                    Final
                                                                                    Diagnosis
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="finalDiagnosis"
                                                                                    value={
                                                                                      result?.finalDiagnosis ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      )}
                                                                    </>
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    ))}
                                              </div>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                      <br />
                    </Tab>
                  )}
                </Tabs>
              </div>
            </div>

            {showAmendmentHistory && amendmentHistory?.length > 0 && (
              <AmendmentGrid
                data={amendmentHistory}
                setData={setAmendmentHistory}
                isLoading
              />
            )}

            <div className="text-end mt-3 mb-3">
              {!IsSubmitresultRequest && !IsAcknowledge ? (
                <button
                  className="btn btn-d btn-secondary px-4"
                  onClick={handlePreviousClick}
                >
                  Previous
                </button>
              ) : null}

              {(IsSubmitresultRequest || IsAcknowledge) && (
                <>
                  <button
                    className="btn btn-d btn-secondary px-4"
                    onClick={handledPreviousClick}
                  >
                    Previous
                  </button>

                  <button
                    className="btn btn-d btn-primary px-4"
                    onClick={
                      IsSubmitresultRequest
                        ? handledSaveResultClick
                        : handleACKResultClick
                    }
                  >
                    {IsSubmitresultRequest ? "Submit" : "Acknowledge"}
                  </button>
                </>
              )}

              {!IsAcknowledgeRequest &&
                !isCancelRequest &&
                !IsAcknowledge &&
                !IsSubmitresultRequest && (
                  <>
                    {actionType !== TypeOfApplicationEnum.amendment && (
                      <button
                        className="btn btn-d btn-secondry  px-4"
                        onClick={handleSaveDraftClick}
                        disabled={btnNameForLoader === "submit-req"}
                      >
                        {btnNameForLoader === "submit-req"
                          ? "Submitting..."
                          : "Save Draft"}
                      </button>
                    )}
                    <button
                      className="btn btn-d btn-primary nextBtn"
                      name="next-click"
                      type="button"
                      onClick={validateForm}
                    >
                      Next
                      {btnNameForLoader == "next-click" ? (
                        <Spinner
                          className="btn-spinner"
                          animation="border"
                          variant="light"
                        />
                      ) : (
                        ""
                      )}
                    </button>
                  </>
                )}
              {!IsAcknowledgeRequest &&
                !IsSubmitresultRequest &&
                !IsAcknowledge &&
                !cancelButtonHidden &&
                isCancelRequest && (
                  <button
                    className="btn btn-d btn-primary nextBtn"
                    name="cancel-request-btn"
                    type="button"
                    onClick={cancelRequest}
                    disabled={btnNameForLoader === "cancel-request-btn"}
                  >
                    Cancel Request
                    {btnNameForLoader == "cancel-request-btn" ? (
                      <Spinner
                        className="btn-spinner"
                        animation="border"
                        variant="light"
                      />
                    ) : (
                      ""
                    )}
                  </button>
                )}
            </div>
          </div>
        )}
      </Container>
      {amendCase === "CASE4" ||
      IsAcknowledgeRequest ||
      IsSubmitresultRequest ||
      IsAcknowledge ||
      isCancelRequest ? (
        ""
      ) : (
        <Modal
          className="popup-2"
          show={showSearchTestsModal}
          onHide={handleCloseSearchTestsModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Assign Tests</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleFormSubmit}>
              <h3>Search for Other Tests</h3>
              <div className="tests-cnt pb-2">
                <div className="mb-3 row">
                  <label
                    htmlFor="flexCheckDesc"
                    className="col-sm-3 col-form-label"
                  >
                    Test Laboratory
                    <span className="star-red">*</span>
                  </label>
                  <div className="col-sm-9">
                    <select
                      className="form-select"
                      aria-label="Test Laboratory"
                      value={selectedTestLaboratory}
                      onChange={(e) => {
                        setSelectedTestLaboratory(e.target.value);
                      }}
                    >
                      <option selected value="All-laboratories">
                        All laboratories
                      </option>

                      {labtestoptions.map((item, index) => (
                        <option key={index} value={item.labGroup}>
                          {item.labGroup}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-1 row"></div>
                <div className="mb-3 row">
                  <label
                    htmlFor="flexCheckDesc"
                    className="col-sm-3 col-form-label"
                  >
                    Test Description
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      id="flexCheckDesc"
                      placeholder=""
                      autoComplete="off"
                      value={testDescription}
                      required
                      onChange={(e) => setTestDescription(e.target.value)}
                      disabled={amendCase == "CASE4" || isCancelRequest}
                      className={`form-control ${
                        !testDescription ? "border-danger op05" : ""
                      }`}
                    />
                    <br />

                    <Button
                      variant="primary"
                      className="float-end"
                      name="submit-reqq"
                      disabled={searchLoading}
                      onClick={handleSearch}
                    >
                      Search
                      {btnNameForLoader == "submit-reqq" ? (
                        <Spinner
                          className="btn-spinner"
                          animation="border"
                          variant="light"
                        />
                      ) : (
                        ""
                      )}
                    </Button>
                  </div>
                </div>
              </div>
              <h3>Examination/Diagnostic Tests</h3>
              <div
                className="tests-cnt csp-maxh-200 csp-overflow-y-auto csp-display-block"
              >
                <h4>Examination/Diagnostic Tests</h4>

                {testOptions
                  .slice()
                  .sort((a, b) => {
                    const stripHtml = (text: any) =>
                      text.replace(/<[^>]*>/g, "").trim();
                    return stripHtml(a.description).localeCompare(
                      stripHtml(b.description)
                    );
                  })
                  .map((test, index) => (
                    <div className="form-check" key={index}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={test.description}
                        id={`testOption${index}`}
                        checked={test.isSelected}
                        onChange={(e) =>
                          toggleTestSelection(
                            test.labCodeMasterID,
                            e.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`testOption${index}`}
                        dangerouslySetInnerHTML={{ __html: test.description }}
                      ></label>
                    </div>
                  ))}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSearchTestsModal}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                handleAddTests();
                handleCloseSearchTestsModal();
              }}
            >
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Footer />
    </>
  );
}

export default CAVSTERSampleDetails;
